<template>
  <div v-if="participantDetails && studyData" class="pii-non-pii-wrapper">
    <div class="row pb-15" v-if="displayMobileView === false">
      <div class="col-md-2">
        <div class="row">
          <div class="col-md-4 pd-0">
            <div class="page header-key">
              Status
              <img alt="edit" v-if="isSiteTeamMember() && canEditStatus() && studyData.status != 'CLOSED_HARD_LOCK' && !canCraUBAccess" src="/static/img/icon-edit.svg" class="ml-5 icon-edit" @click="openEditStatusModal()" style="cursor:pointer" />
            </div>
            <div v-if="participantDetails.status" class="value">
              <div v-if="participantDetails.status === 'ACTIVEWMODIFICATION'">
                <div class="active-text">Active</div>
                <div class="modificationsText">
                  <span @click="openEditStatusModal('view')" style="cursor:pointer">with Modifications</span>
                </div>
              </div>
              <div v-else-if="participantDetails.status === 'ACTIVEWITHOUTAPP'">
                <div class="active-text">Active</div>
                <div class="modificationsText">
                  <span class="text-primary">no App</span>
                </div>
              </div>
              <div v-else>{{ participantStatus }}</div>
            </div>
          </div>
          <div class="col-md-8 pl-10 pr-0">
            <div class="page header-key">
              Participant ID
              <span v-if="(canEditParticipantId() && isDataLoadingFinish) || (canEditParticipantId() && isDataLoadingFinishFlag)" @click="openEditModal()">
                <img alt="img" src="/static/img/icon-edit.svg" class="ml-5 icon-edit" style="cursor:pointer" />
              </span>
            </div>
            <div class="value" v-if="participantDetails.userDefinedParticipantId" v-html="convertArrayStringHtml('', participantDetails.userDefinedParticipantId)"></div>
            <div v-else>--</div>
          </div>
        </div>
      </div>
      <div class="col-md-3 pd-0">
        <div class="page header-key">THREAD ID</div>
        <div v-if="participantDetails.id" class="value">
          {{ participantDetails.id }}
        </div>
        <div v-else>--</div>
      </div>
      <div class="col-md-3" v-if="checkParticipantRegistrationConfigDetails('firstName') || checkParticipantRegistrationConfigDetails('lastName')">
        <div class="row">
          <div class="col-6 pl-0" v-if="checkParticipantRegistrationConfigDetails('firstName')">
            <div class="page header-key">
              First Name
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('First Name')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.firstName" class="value">
              {{ participantDetails.firstName }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-6 pl-0" v-if="checkParticipantRegistrationConfigDetails('lastName')">
            <div class="page header-key">
              Last Name
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Last Name')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.lastName" class="value">
              {{ participantDetails.lastName }}
            </div>
            <div v-else>--</div>
          </div>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="col-auto" v-if="studyData && studyData.isSegmentSupported">
          <div class="page header-key">
            Cohort
            <span class="site-modal">
              <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('segmentId')">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
            </span>
          </div>
          <div class="value">
            {{ getCohortName(participantDetails.segmentId) }}
          </div>
        </div>
        <div class="col-md-3">
          <div class="page header-key">
            Site ID
            <span class="site-modal">
              <button type="button" class="ml-5 icon-edit" v-if="rolesAccessPermissions()" data-toggle="modal" data-target="#siteIdModal" @click="doSomethingOnHidden()" style="cursor:pointer">
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
              <button v-if="transferHistory.length > 0 && isAvailableHistory" type="button" data-toggle="modal" data-target="#transferIdModal">
                <img alt="history" src="../../assets/noun_History_3323396 1.svg" height="20px" width="20px" />
              </button>
            </span>
          </div>
          <div v-if="participantDetails.userSiteId" class="value">
            {{ participantDetails.userSiteId }}
          </div>
          <div v-else>--</div>
        </div>
        <div class="col-md-9 pb-5">
          <div class="">
            <div class="row">
              <div class="col-md-5 pd-0" v-if="checkParticipantRegistrationConfigDetails('gender')">
                <div class="page header-key">
                  Gender
                  <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                    <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Gender')">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  </span>
                </div>
                <div v-if="isSiteTeamMember() && participantDetails.gender" class="value truncate">
                  {{ participantDetails.gender }}
                </div>
                <div v-else>--</div>
              </div>
              <div class="col-md-7">
                <div class="header-key page" v-if="checkParticipantRegistrationConfigDetails('ageRange')">
                  Age Range
                  <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                    <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Age range')">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  </span>
                </div>
                <div class="header-key page" v-if="checkParticipantRegistrationConfigDetails('dob') || checkParticipantRegistrationConfigDetails('dobWithMonthYear') || checkParticipantRegistrationConfigDetails('dobWithYear') || checkParticipantRegistrationConfigDetails('birthDate')">
                  DOB
                  <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                    <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('DOB')">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  </span>
                </div>
                <div>
                  <span v-if="isSiteTeamMember() && participantDetails.ageRange && checkParticipantRegistrationConfigDetails('ageRange')" class="value">{{ participantDetails.ageRange }}</span>
                  <span v-if="isSiteTeamMember()" class="value">
                    <span v-if="showDOB && (participantDetails.dob || participantDetails.birthDate)">{{ new Date(participantDetails.dob) | dateFormat("MMMM DD YYYY") }}</span>
                    <span v-else-if="showDobWithMonthYear && participantDetails.dobWithMonthYear">{{ new Date(participantDetails.dobWithMonthYear) | dateFormat("MM, YYYY") }}</span>
                    <span v-else-if="showDobWithYear && participantDetails.dobWithYear">{{ new Date(participantDetails.dobWithYear) | dateFormat("YYYY") }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="displayMobileView === true">
      <div class="col pr pl">
        <div class="page header-key ">
          Status
          <img alt="img" v-if="isSiteTeamMember() && canEditStatus()" src="/static/img/icon-edit.svg" class="ml-5 icon-edit" @click="openEditStatusModal()" style="cursor:pointer" />
        </div>
        <div v-if="participantDetails.status" class="value">
          <div v-if="participantDetails.status === 'ACTIVEWMODIFICATION'">
            <div class="active-text">Active</div>
            <div class="modificationsText">
              <span @click="openEditStatusModal('view')" style="cursor:pointer">with Modifications</span>
            </div>
          </div>
          <div v-else>{{ participantStatus }}</div>
        </div>
      </div>
      <div class="col p-0">
        <div class="page header-key">
          Participant ID
        </div>
        <div v-if="participantDetails.userDefinedParticipantId" class="value">
          {{ truncateUserDefinedParticipantId() }}
        </div>
      </div>
      <div class="col">
        <div class="page header-key">THREAD ID</div>
        <span v-if="!participantDetails.showMore && participantDetails.id">{{ participantDetails.id.slice(0, 8) }}...</span>
        <span v-if="participantDetails.showMore && participantDetails.id">{{ participantDetails.id }} </span>
        <a v-if="!participantDetails.showMore" class="cursor_pointer table-content-color fs-12 link" @click="toggleShowMore()">
          <u>Show</u>
        </a>
        <a v-if="participantDetails.showMore" class="cursor_pointer table-content-color fs-12 link" @click="toggleShowMore()"><u>Less</u></a>
      </div>
    </div>
    <div class="toggle-wrapper d-none d-md-block">
      <!-- SiteId Modal Start -->
      <div class="modal fade" id="siteIdModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body mr-6 ml-6 mt-4">
              <div class="modal-title">
                Select a Site to Transfer Participant
              </div>
              <div class="siteId-box mt-13">
                <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="Enter site name or ID" v-model="searchedSite" />
                <div class="page-modal mt-5">
                  <div class="wrapper">
                    <div class="content" v-if="studyResponse">
                      <div class="select-scroll activity-builder-select-options" v-for="site in searchedSitesList" :key="site.userSiteId">
                        <div v-on:click="selectSiteToTransfer(site)" class="selectedSite" :id="'selectedSite' + site.userSiteId">
                          <label class="Site-ID"
                            >{{ site.userSiteId }}
                            <span
                              ><label :for="site.userSiteId" class="Site-Name">{{ site.name }}</label></span
                            >
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="custom-dropdown mt-18 w-298">
                <div class="form-group" style="margin-bottom: 0px !important;">
                  <div id="siteIdSelectBox" class="multiselect filter-form-box">
                    <div class="selectBox" @click="showSiteTransferReason">
                      <div class="fakeclass nsiteId-input">
                        <input name="siteId" :value="newSiteTransferReason" id="select-question" readonly placeholder="Select a reason for the change" :tabindex="10" class="form-control input-md th-comman-select-box" />
                      </div>
                      <div class="overSelect"></div>
                    </div>
                    <div id="showSiteTransferReason" class="select-scroll activity-builder-select-options" v-if="isSiteTransferReason">
                      <label data-v-2f4812d0="" id="Notification-value" class="pi-width notificationLabel pl-6" v-for="(reason, index) in listOfSiteTransferReason" :value="reason.value" :key="index" @click="onSiteTransferReasonClick(reason.value)">
                        {{ reason.name }}
                      </label>
                    </div>
                  </div>
                </div>
                <div v-if="this.newSiteTransferReason == 'Other'" class="fakeclass siteId-input">
                  <input type="text" class="form-control py-2 my-2" v-model="userReasonForOther" placeholder="Enter reason for change" />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class=" bg-white text-gray" data-dismiss="modal" @click="dropNewSiteData">
                Cancel
              </button>
              <button type="button" :disabled="!checkAllConditions()" class="modal-btn btn fs-12 btn-primary btn-continue-prim" data-toggle="modal" data-target="#confirmTransferModal" data-dismiss="modal">
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- transfer history modal -->
      <div class="modal fade" id="transferIdModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Transfer History</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="tarnsfer-table-div">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">Transfer Date</th>
                      <th scope="col">From Site</th>
                      <th scope="col">To Site</th>
                      <th scope="col">Requested By</th>
                      <th scope="col">Accepted By</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(T, tid) in transferHistory" :key="tid">
                      <td v-if="T.createdAt">
                        {{ T.createdAt | Date_FORMAT }}
                      </td>
                      <td v-if="T.fromSiteId">{{ T.fromSiteId }}</td>
                      <td v-if="T.toSiteId">{{ T.toSiteId }}</td>
                      <td v-if="T.createdBy">{{ T.createdBy }}</td>
                      <td v-if="T.reviewedBy">{{ T.reviewedBy }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade siteIdModel-2" id="confirmTransferModal" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body">
              <p class="question-title">
                Are you sure you want to transfer the following participant to site
                <span class="d-block"
                  ><b>{{ newSite.userSiteId }} - {{ newSite.name }}</b></span
                >
              </p>
              <div class="participant-info">
                <div class="row fs-12 ">
                  <div class="col-md-5 p-0">
                    <div class="text-lightGray">Participant ID</div>
                    <span class="fs-14 word-break" v-if="participantDetails.userDefinedParticipantId" v-html="convertArrayStringHtml('', participantDetails.userDefinedParticipantId)"></span>
                  </div>
                  <div class="col-md-6 p-0">
                    <div class="text-lightGray">THREAD ID</div>
                    <span class="fs-14 word-break">{{ participantDetails.id }}</span>
                  </div>
                </div>
              </div>
              <div class="d-flex pt-28 justify-content-center">
                <div>
                  <button type="button" class="btn btn-1 fs-14  mr-22" @click="dropNewSiteData" data-dismiss="modal">
                    No
                  </button>
                </div>
                <div>
                  <button type="button" @click="sendSiteDataToTransfer()" class="btn btn-2 fs-14">
                    Yes
                  </button>
                </div>
              </div>
              <p class="note"><b>Note: &nbsp;</b>Approval of the transfer is required by the site team of the receiving site.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade siteIdModel-2" id="participantDetailsModifyModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" :class="{ verifyPhone: isVerificationModal }">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="participantModifyValue == 'segmentId'">Change Cohort</h5>
            <h5 v-else-if="participantModifyValue == 'verificationPhone'">
              Change Verification Phone Number
            </h5>
            <h5 v-else>Change {{ participantModifyValue }}</h5>
            <button type="button" class="close arrow-change" data-dismiss="modal" aria-label="Close" @click="cancelParticipant()">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body" v-if="participantDetailsModifyModal">
            <div v-if="participantModifyValue == 'email'">
              <input type="text" class="form-control py-2 my-2" v-model="participantInfo.email" placeholder="Enter Email ID" />
            </div>
            <div v-if="participantModifyValue == 'First Name'">
              <input type="text" class="form-control py-2 my-2" v-model="participantInfo.firstName" placeholder="Enter First Name" />
            </div>
            <div v-if="participantModifyValue == 'Last Name'">
              <input type="text" class="form-control py-2 my-2" v-model="participantInfo.lastName" placeholder="Enter Last Name" />
            </div>
            <div v-if="participantModifyValue == 'Gender'">
              <b-form-select class="mt-20 mb-10" v-model="participantInfo.genderIdentifier" @change="setGenderValue($event)">
                <option v-for="g in gender" :value="g.lookupId" :key="g.key">
                  {{ g.lookupValue }}
                </option>
              </b-form-select>
            </div>
            <div v-if="participantModifyValue == 'Parent/Caregiver First Name'">
              <input type="text" class="form-control py-2 my-2" v-model="participantInfo.parentOrCgFirstName" placeholder="Enter Parent/Caregiver First Name" />
            </div>
            <div v-if="participantModifyValue == 'Parent/Caregiver Last Name'">
              <input type="text" class="form-control py-2 my-2" v-model="participantInfo.parentOrCgLastName" placeholder="Enter Parent/Caregiver Last Name" />
            </div>
            <div v-if="participantModifyValue == 'DOB'">
              <span v-if="showDOB">
                <date-picker v-model="participantInfo.dob" type="date" class="mx-datepicker ml-25"></date-picker>
              </span>
              <span v-else-if="showDobWithMonthYear">
                <date-picker v-model="participantInfo.dobWithMonthYear" type="month" class="mx-datepicker ml-25"></date-picker>
              </span>
              <span v-else-if="showDobWithYear">
                <date-picker v-model="participantInfo.dobWithYear" type="year" class="mx-datepicker ml-25"></date-picker>
              </span>
            </div>
            <div v-if="participantModifyValue == 'Age range'">
              <b-form-select class="mt-20 mb-10" v-model="participantInfo.ageRangeIdentifier" @change="setAgeRangeValue($event)">
                <option v-for="ageval in ageRange" :value="ageval.lookupId" :key="ageval.key">
                  {{ ageval.lookupValue }}
                </option>
              </b-form-select>
            </div>
            <div v-if="participantModifyValue == 'Address'">
              <textarea rows="3" class="form-control py-2 my-2" v-model="participantInfo.address" placeholder="Enter Address"></textarea>
            </div>
            <div v-if="participantModifyValue == 'Phone'">
              <vue-tel-input
                class="mb-0"
                :value="contactPhone"
                :dropdownOptions="{ showDialCodeInSelection: true }"
                mode="national"
                @onInput="onInputContactPhoneNumber"
                @country-changed="contactPhoneValidated"
                @validate="contactPhoneValidated"
                @onValidate="contactOnPhoneValidated"
                disabledFetchingCountry
                placeholder="Enter Phone"
                validCharactersOnly
                type="tel-input"
                name="contactPhoneNumber"
                ref="contactPhoneNumber"
                :preferredCountries="preferredCountries"
                :defaultCountry="contactPhoneCountryCode"
                v-vue-tel-label.nolabels
              ></vue-tel-input>
            </div>
            <div v-if="participantModifyValue == 'Non-mobile phone'">
              <input type="text" class="form-control py-2 my-2" v-model="participantInfo.nonMobilePhoneNumber" placeholder="Enter Non-mobile phone" maxlength="10" />
            </div>
            <div v-if="participantModifyValue == 'segmentId'">
              <b-form-select class="mt-20 mb-10" v-model="participantInfo.segmentId">
                <option :value="null">Pending</option>
                <option :value="cohort.id" v-for="cohort in this.studyData.segments" :key="cohort.id">{{ cohort.name }}</option>
              </b-form-select>
            </div>
            <div v-if="participantModifyValue == 'How did you hear about us'">
              <b-form-select class="mt-20 mb-10" v-model="participantInfo.howDidYouHear">
                <option v-for="hval in howDidYouHear" :value="hval" :key="hval">
                  {{ hval }}
                </option>
              </b-form-select>
            </div>
            <!-- TUR-61129 -->
            <div v-if="participantModifyValue == 'verificationPhone' && (this.isVerificationPhone || studyData.verificationMethod == 'both') && this.isSiteDetailsLoaded">
              <vue-tel-input
                class="mb-0"
                :value="verificationPhone"
                :dropdownOptions="{ showDialCodeInSelection: true }"
                mode="national"
                @onInput="onInputVerificationPhoneNumber"
                @country-changed="countryChanged"
                @validate="phoneValidated"
                @onValidate="onPhoneValidated"
                disabledFetchingCountry
                placeholder="Enter Verification Phone Number (Mobile)"
                validCharactersOnly
                type="tel-input"
                name="phoneNumber"
                ref="verificationPhone"
                :preferredCountries="preferredCountries"
                :defaultCountry="verificationPhoneCountryCode"
                v-vue-tel-label.nolabels
              ></vue-tel-input>
            </div>
            <!-- TUR-61129 -->
            <div class="d-flex pt-28 justify-content-center">
              <div>
                <button type="button" class="btn btn-1 fs-14  mr-22" data-dismiss="modal" @click="cancelParticipant()">
                  Cancel
                </button>
              </div>
              <div>
                <button type="button" @click="updateParticpantValue()" class="btn btn-2 fs-14" :disabled="isDisabled">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="toggle-wrapper">
      <div v-if="!isExpand" @click="expandSection()" :class="isExpand ? null : 'collapsed'" :aria-expanded="isExpand" v-b-toggle.collapse-piiandnon-pii variant="primary" class="toggle-text">Expand<span></span></div>
    </div>
    <b-collapse v-model="isExpand" id="collapse-piiandnon-pii" class="mt-2">
      <div class="separator"></div>
      <b-card>
        <div class="row pb-20 mt-2" v-if="!isFirstRowCanBeAcessiable">
          <div class="col-md-2" v-if="checkParticipantRegistrationConfigDetails('email')">
            <div class="header-key page">
              Email <span class="mandatory">*</span><img alt="img" v-if="participantDetails.email && canEditEmailId()" src="/static/img/icon-edit.svg" class="ml-5 icon-edit" @click="openEditEmailModal()" style="cursor:pointer" />
              <span class="site-modal" v-if="!participantDetails.email && participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" :disabled="isVerificationPhone" :class="{ 'pencil-icon-disabled': isVerificationPhone }" data-target="#participantDetailsModifyModal" @click="editenabledfield('email')">
                  <i class="fa fa-pencil" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="hover" data-content="Email cannot be added when Verification Method is equal to Phone." data-html="true"> </i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && this.isVerificationPhone === false" class="value">
              {{ participantDetails.email }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2">
            <div class="header-key page">Latest Consented On</div>
            <div v-if="participantDetails.latestConsentedOn" class="value">
              {{ new Date(participantDetails.latestConsentedOn) | dateFormat("DD MMM YYYY") }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="checkParticipantRegistrationConfigDetails('parentOrCgFirstName')">
            <div class="header-key page">
              Parent/Caregiver First Name
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Parent/Caregiver First Name')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.parentOrCgFirstName" class="value">
              {{ participantDetails.parentOrCgFirstName }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2 pl-0 pr-0" v-if="checkParticipantRegistrationConfigDetails('parentOrCgLastName')">
            <div class="header-key page">
              Parent/Caregiver Last Name
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Parent/Caregiver Last Name')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.parentOrCgLastName" class="value">
              {{ participantDetails.parentOrCgLastName }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="participantDetails.participantLanguage && participantDetails.participantLanguage.display_name != undefined">
            <div class="header-key page">Language</div>
            <div v-if="participantDetails.participantLanguage && participantDetails.participantLanguage.display_name" class="value">
              {{ participantDetails.participantLanguage.display_name }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="participantDetails.countryName != undefined && checkParticipantRegistrationConfigDetails('country')">
            <div class="header-key page">Site Country</div>
            <div v-if="participantDetails.countryName" class="value">
              {{ participantDetails.countryName }}
            </div>
            <div v-else>--</div>
          </div>
          <!--85639 - Custom registration field-->
          <template v-if="shoulsShowCustomFields()">
            <div class="col-md-2" v-for="(item, i) in participantDetails.customFields" :key="i">
              <span v-for="(value, key, index) in item" :key="index">
                <div class="page header-key">
                  <span v-if="index === 0">{{ value }}</span>
                  <span class="site-modal">
                    <button v-if="index === 0 && canSiteTeamUserEditCustomFields()" type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsCustomFileds" @click="editCustomFields(item, i)">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                  </span>
                </div>
                <span v-if="index === 1">
                  <div class="value" v-if="isCustomFieldsDataVisible()">
                    {{ value }}
                  </div>
                  <div v-if="!isCustomFieldsDataVisible()">--</div>
                </span>
              </span>
            </div>
          </template>
        </div>
        <div class="row pb-20">
          <div class="col-md-2">
            <div class="heading page header-key truncate">Device Usage</div>
            <div class="row" v-if="participantDetails.participantUsedDevices">
              <div class="device-usage inline-ele" v-for="(devices, index) in participantDetails.participantUsedDevices" :key="index">
                <span v-if="devices.deviceName && devices.deviceName.toLowerCase() == 'android'" aria-hidden="true" class="img-wrapper">
                  <img alt="img" title="android" v-if="!devices.lastUsedDevice" src="static/img/android_grey.png" />
                  <img alt="img" title="android" v-if="devices.lastUsedDevice" src="static/img/android_black.png" />
                </span>
                <span v-if="devices.deviceName && devices.deviceName.toLowerCase() == 'ios'" aria-hidden="true" class="img-wrapper">
                  <img alt="img" title="ios" v-if="!devices.lastUsedDevice" src="static/img/apple_grey.png" />
                  <img alt="img" title="ios" v-if="devices.lastUsedDevice" src="static/img/apple_black.png" />
                </span>
                <span v-if="devices.deviceName && devices.deviceName.toLowerCase() == 'iwatch'" aria-hidden="true" class="img-wrapper">
                  <img alt="img" title="iwatch" v-if="!devices.lastUsedDevice" src="static/img/watch_grey.png" />
                  <img alt="img" title="iwatch" v-if="devices.lastUsedDevice" src="static/img/watch-black.png" />
                </span>
                <span v-if="!devices.deviceName">--</span>
              </div>
            </div>
          </div>
          <div class="col-md-2" v-if="checkParticipantRegistrationConfigDetails('address')">
            <div class="header-key page">
              Address
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Address')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.address" class="value">
              {{ participantDetails.address }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2 " v-if="participantDetails.city != undefined && checkParticipantRegistrationConfigDetails('city')">
            <div class="header-key page">City</div>
            <div v-if="isSiteTeamMember() && participantDetails.city" class="value">
              {{ participantDetails.city }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="participantDetails.state != undefined && checkParticipantRegistrationConfigDetails('stateProvince')">
            <div class="header-key page">State/Province</div>
            <div v-if="isSiteTeamMember() && participantDetails.state" class="value">
              {{ participantDetails.state }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="participantDetails.zipcode != undefined && checkParticipantRegistrationConfigDetails('zipCode')">
            <div class="header-key page">Zip/Postal code</div>
            <div v-if="isSiteTeamMember() && participantDetails.zipcode" class="value">
              {{ participantDetails.zipcode }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="participantDetails.country != undefined && checkParticipantRegistrationConfigDetails('country')">
            <div class="header-key page">Address Country</div>
            <div v-if="isSiteTeamMember() && participantDetails.country" class="value">
              {{ participantDetails.country }}
            </div>
            <div v-else>--</div>
          </div>
        </div>
        <div class="row pb-20" v-if="!isThirdRowCanBeAcessiable">
          <div class="col-md-3 col-lg-2" v-if="checkParticipantRegistrationConfigDetails('phoneNumber')">
            <div class="header-key page">
              Phone
              <i
                class="fa fa-info-circle help_icon ml-4"
                aria-hidden="true"
                data-toggle="popover"
                tabindex="0"
                data-trigger="focus"
                data-content="This is the mobile phone number provided at registration as a contact number for the participant. It can be used for communicating with the participant via SMS (text), if the participant has not opted out from receiving SMS notifications. This phone number may be the same or different than what is used to authenticate the participant's identity during login or when the participant’s Verification Method is Phone."
                data-html="true"
              >
              </i>
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" data-type="Phone">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.phoneNumber" class="value">
              {{ participantDetails.phoneNumber | national(participantDetails.countryCode) | trim0 }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="checkParticipantRegistrationConfigDetails('nonMobilePhoneNumber')">
            <div class="header-key page">
              Non-mobile phone
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('Non-mobile phone')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isSiteTeamMember() && participantDetails.nonMobilePhoneNumber" class="value">
              {{ participantDetails.nonMobilePhoneNumber }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-2" v-if="participantDetails.source && participantDetails.status !== 'ACTIVEWITHOUTAPP'">
            <div class="header-key page">Source</div>
            <div v-if="participantDetails.source" class="value">
              {{ participantSourcesText[participantDetails.source] }}
            </div>
            <div v-else>--</div>
          </div>
          <div class="col-md-4 col-lg-2 pr-0 pl-5" v-if="checkParticipantRegistrationConfigDetails('howDidYouHear')">
            <div class="header-key page">
              How did you hear about us?
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && participantDetails.status !== 'WITHDRAWSTUDY' && participantDetails.status !== 'DISCONTINUED' && canEditParticipantInfo()">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" @click="editenabledfield('How did you hear about us')">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
              <div v-if="isSiteTeamMember() && participantDetails.howDidYouHear" class="value">
                {{ participantDetails.howDidYouHear }}
              </div>
              <div v-else>--</div>
            </div>
          </div>
          <!-- TUR-61129 -->
          <div class="col-md-2 " v-if="!this.isOpenEnrollment && this.studyData.verificationMethod && this.studyData.verificationMethod === 'both'">
            <div class="header-key page">
              Verification Method
              <!-- TUR-61129 -->
              <i
                class="fa fa-info-circle help_icon ml-4"
                aria-hidden="true"
                data-toggle="popover"
                tabindex="0"
                data-trigger="focus"
                data-content="The participant's Verification Method indicates how the participant will authenticate their identity by confirming either their email address or verification phone number, depending on what was selected when the participant was added to the study. When the Verification Method is Phone, the participant's Verification Phone (Mobile) will be used to authenticate their identity via SMS (text) at each login. This mobile number may be the same or different than their contact phone number. If the Verification Method is Email, the participant's email address will be used for authentication purposes, when required."
                data-html="true"
              >
              </i>
              <span class="site-modal"> </span>
            </div>
            <div class="value">
              {{ modifyVerificationText(participantDetails.verificationMethod) }}
            </div>
          </div>
          <div class="col-md-3 col-lg-2 pr-0 pl-5" v-if="!this.isOpenEnrollment && isStudyVerificationPhoneVisible">
            <div class="header-key page">
              Verification Phone (Mobile)
              <i class="fa fa-info-circle help_icon ml-4" aria-hidden="true" data-toggle="popover" tabindex="0" data-trigger="focus" data-content="The participant's Verification Phone (Mobile) is the number used to authenticate a participant's identity via SMS (text) for each login. This mobile number may be the same or different than their contact phone number." data-html="true"> </i>
              <span class="site-modal" v-if="participantDetails.status !== 'DISQUALIFIED' && canEditParticipantInfo() && participantDetails.verificationMethod == 'phone'">
                <button type="button" class="ml-5 icon-edit" data-toggle="modal" data-target="#participantDetailsModifyModal" data-type="verificationPhone">
                  <i class="fa fa-pencil" aria-hidden="true"></i>
                </button>
              </span>
            </div>
            <div v-if="isVerificationPhone && isVerificationPhoneAccess" class="value">
              {{ participantDetails.mobile | national(participantDetails.mobileCountryCode) | trim0 }}
            </div>
          </div>
          <!-- TUR-61129 -->
        </div>
        <div class="seperator mb-12"></div>
        <!-- Participant level Statuses START-->
        <div class="d-flex ml-15 mr-15 flex-column">
          <div v-b-toggle.participantStatuses class="value cursor_pointer collapse-trigger disable-text-selection mb-8">
            Activity and Form Status
            <img src="/static/img/chevron-dropdown.svg" class="dropdown-icon" alt="Collapse action icon" />
          </div>
        </div>
        <b-collapse id="participantStatuses" class="mt-2">
          <div class="d-flex ml-15 mr-15">
            <div class="mr-32">
              <div class="header-key page">
                Approved Status
                <img alt="img" v-if="isSiteTeamMember() && !user.readOnly && !this.isLocked && !canCraUBAccess" src="/static/img/icon-edit.svg" class="ml-5 icon-edit cursor_pointer" @click="toggleApproveStatus" />
              </div>
              <div class="value">{{ approvalStatusTextSetNewStatus }}</div>
            </div>

            <div class="mr-32">
              <div class="header-key page">
                Verified Status
                <img alt="img" v-if="(canCraAccess || canCraUBAccess) && !this.isLocked" src="/static/img/icon-edit.svg" class="ml-5 icon-edit cursor_pointer" @click="toggleVerifyStatus" />
              </div>
              <div class="value">{{ verifiedStatusTextNewStatus }}</div>
            </div>

            <div class="mr-32">
              <div class="header-key page">
                Signed Off Status
                <img alt="img" v-if="canPiAccess && isVerified && isApproved && !this.isLocked" src="/static/img/icon-edit.svg" class="ml-5 icon-edit cursor_pointer" @click="toggleSignOffStatus" />
              </div>
              <div class="value">{{ signedOffStatusTextNewStatus }}</div>
            </div>

            <div class="mr-32">
              <div class="header-key page">
                Reviewed Status
                <img alt="img" v-if="(canCraAccess || canDmAccess || canCraUBAccess) && !this.isLocked" src="/static/img/icon-edit.svg" class="ml-5 icon-edit cursor_pointer" @click="toggleReviewStatus" />
              </div>
              <div class="value">{{ reviewedStatusTextNewStatus }}</div>
            </div>

            <div class="mr-32">
              <div class="header-key page">
                Locked Status
                <img alt="img" v-if="canCraAccess || canDmAccess || canCraUBAccess" src="/static/img/icon-edit.svg" class="ml-5 icon-edit cursor_pointer" :class="{ disabled: removeActivityEditIcon }" @click="toggleLockedStatus" />
              </div>
              <div class="value">{{ lockedStatusTextNewStatus }}</div>
            </div>
          </div>
          <div class="separator"></div>
        </b-collapse>
        <!-- Participant level Statuses END-->
        <div class="toggle-wrapper">
          <div v-if="isExpand" @click="isExpand = !isExpand" v-b-toggle.collapse-piiandnon-pii variant="primary" class="toggle-text colls">Collapse<span class="collapsed"></span></div>
        </div>
      </b-card>
    </b-collapse>

    <b-modal v-model="isParticipantEditModalBoxVisible" id="edit-participant-modal" ref="editParticipantModal" hide-footer hide-header :no-close-on-esc="noCloseOnOutsideClick" :no-close-on-backdrop="noCloseOnOutsideClick" @hidden="resetAllTheValues">
      <div>
        <div class="cross" @click="onCloseOfModalBox">
          <img alt="img" src="static/img/cross.png" style="cursor:pointer" />
        </div>
        <div class="modal-title">
          <b>
            <p class="fs-16 pl-10 pr-10">Edit Participant ID<br /></p>
          </b>
        </div>
        <div class="pl-10 pr-10 blue-banner">
          <b-col cols="12" class="p-0">
            <div class="fw-bold title">THREAD ID</div>
            <div class="description">{{ participantDetails.id }}</div>
          </b-col>
        </div>
        <div class="pt-20">
          <b-col cols="12" class="p-0" v-if="studyResponse && studyResponse.participantIdFormatConfigured && !studyResponse.participantIdFormatConfigured.isFormattingChecked">
            <input type="text" class="form-control highlighted" v-model="userDefinedParticipantId" placeholder="Enter new participant ID" @keyup="validateFields()" />
            <div class="error-style" v-if="participantIDdisabled">
              Participant ID is required
            </div>
          </b-col>
          <div class="otp-input scrollbar participant-profile" v-if="studyResponse && studyResponse.participantIdFormatConfigured && studyResponse.participantIdFormatConfigured.isFormattingChecked && isFormatUpdate === false">
            <otpInputService :options="studyResponse.participantIdFormatConfigured" v-for="(digit, index) in formattingArray.formatArray" :key="index" v-model="formattingArray.formatArray[index]" :data-fixedCharacters="fixedCharactersIndex" data-page="participant-profile" @keyup.native="validateFields()" :showOldFormat="false"></otpInputService>
          </div>
          <div class="otp-input scrollbar participant-profile" v-if="studyResponse && studyResponse.participantIdFormatConfigured && studyResponse.participantIdFormatConfigured.isFormattingChecked && isFormatUpdate === true">
            <otpInputService :options="studyResponse.participantIdFormatConfigured" v-for="(digit, index) in userDefinedArray" :key="index" v-model="userDefinedArray[0]" data-page="participant-profile" @keyup.native="validateFields(true)" :showOldFormat="true" :data-fixedCharacters="fixedCharactersIndex"></otpInputService>
          </div>
          <div class="error-style">{{ hasError.idErrorMsg }}</div>
        </div>
        <div v-if="participantDetails.status != 'NOTINVITED' && participantDetails.version >= 1" class="pt-20">
          <b-col cols="12" class="p-0">
            <textarea v-model="reasonForChange" @keyup="validateFields()" class="form-control highlighted text-area" rows="3" cols="30" placeholder="Enter reason for change."></textarea>
          </b-col>
          <div class="error-style">{{ hasError.reasonErrorMsg }}</div>
        </div>
        <b-col cols="12" class="pr-0 text-right" v-if="participantDetails.userDefinedParticipantId && participantDetails.status != 'NOTINVITED'">
          <b-btn class="mt-20 br-3 save-btn-already-save" :disabled="isSaveBtnDisabled || ShouldDisableSaveBtn()" size="md" variant="primary" @click="updateParticipantID()">Save</b-btn>
        </b-col>
        <b-col cols="12" class="text-center" v-else>
          <b-btn class="mt-20 mr-10 br-3 cancel-btn" size="md" variant="primary" @click="cancelEdit()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 save-btn" size="md" variant="primary" :disabled="isSaveBtnDisabled || ShouldDisableSaveBtn()" @click="updateParticipantID()">Save</b-btn>
        </b-col>
      </div>
    </b-modal>

    <!-- Edit participant status modal -->
    <b-modal ref="editParticipantStatusModal" id="edit-participant-status-modal" hide-footer hide-header body-class="modal-body-custom pt-0 pb-29">
      <div>
        <img alt="img" class="close-icon" src="static/img/close-new.svg" @click="$refs.editParticipantStatusModal.hide()" style="cursor:pointer" />
      </div>
      <div class="clearfix"></div>
      <div>
        <b>
          <p class="fs-18 pl-10 pr-10" style="color:#666669">Change Participant Status<br /></p>
        </b>
      </div>
      <div>
        <b-row class="rowDiv pt-10 pb-10 pr-10">
          <b-col cols="4">
            <div class="subHeading pb-5">Participant ID</div>
            <div style="word-break:break-all;color:#4a4a4a;">
              {{ participantDetails.userDefinedParticipantId }}
            </div>
          </b-col>
          <b-col cols="8">
            <div class="subHeading pb-5">THREAD ID</div>
            <div style="width: 283px;color:#4a4a4a;">
              {{ participantDetails.id }}
            </div>
          </b-col>
        </b-row>
        <b-form-select class="mt-20 mb-10" v-model="currentParticipantStatus" @input="statusChanged()" style="color:#4a4a4a;" :disabled="disableStatusEdit || (currentParticipantStatus === 'ACTIVEWMODIFICATION' && showActivitiesNotifications)" :style="[disableStatusEdit || (currentParticipantStatus === 'ACTIVEWMODIFICATION' && showActivitiesNotifications) ? { cursor: 'not-allowed' } : {}]">
          <option v-for="(status, index) in statusOptions" :value="status.value" :key="index">{{ status.name }}</option>
        </b-form-select>
        <b-form-select class="mt-20 mb-10" v-model="selectedReason" v-if="currentParticipantStatus === 'ACTIVEWMODIFICATION' && !showActivities">
          <option value="" selected>Select a reason for the change</option>
          <option v-for="(reason, index) in reasons" :value="reason.value" :key="index">{{ reason.name }}</option>
        </b-form-select>
        <b-form-select style="cursor: not-allowed" :disabled="disabledFlag" class="mt-20 mb-10" v-model="selectedReason" v-if="(participantDetails.status === 'ACTIVEWMODIFICATION' && withModificationsLinkClickFlg && hideChangeBtn) || modifyclickFlg">
          <option value="" selected>Select a reason for the change</option>
          <option v-for="(reason, index) in reasons" :value="reason.value" :key="index">{{ reason.name }}</option>
        </b-form-select>
        <b-form-textarea style="cursor: not-allowed" :disabled="disabledFlag" v-if="(participantDetails.status === 'ACTIVEWMODIFICATION' && withModificationsLinkClickFlg && hideChangeBtn) || (modifyclickFlg && otherReason != '')" placeholder="Enter reason for change" rows="3" v-model="otherReason"></b-form-textarea>
        <b-form-textarea v-if="selectedReason === 'Other' && !showActivities && currentParticipantStatus === 'ACTIVEWMODIFICATION'" placeholder="Enter reason for change" rows="3" v-model="otherReason"></b-form-textarea>
        <div v-if="(showActivities === true || (participantDetails.status === 'ACTIVEWMODIFICATION' && currentParticipantStatus === 'ACTIVEWMODIFICATION')) && showActivitiesNotifications">
          <b-row class="pb-5">
            <b-col cols="7" class="p-0">Disable activities</b-col>
            <b-col cols="5" class="p-0" :style="[!isSiteTeamUsers() ? { cursor: 'not-allowed' } : {}]">
              <b-form-checkbox v-model="disableActivitiesFlag" :disabled="(getPredinedDisableTasks.length > 0 || getPredinedDisableCustomNotifications.length > 0 ? true : false) || !isSiteTeamUsers()" v-on:change="disableActivities()">Disable all activities</b-form-checkbox>
            </b-col>
          </b-row>
          <div class="activitiesDiv">
            <div v-for="(task, index) in tasks" class="pb-5" :key="index">
              <b-form-checkbox :disabled="(getPredinedDisableTasks.length > 0 || getPredinedDisableCustomNotifications.length > 0 ? true : false) || !isSiteTeamUsers()" v-model="task.active" @input="updateChangeStatus()" :style="[task.active ? { color: '#b0bac9' } : {}, !isSiteTeamUsers() ? { cursor: 'not-allowed' } : {}]"> {{ task.name }}</b-form-checkbox>
            </div>
          </div>
          <b-row class="pt-10 pb-5">
            <b-col cols="7" class="p-0">Disable notifications</b-col>
            <b-col cols="5" class="p-0">
              <b-form-checkbox :disabled="(getPredinedDisableTasks.length > 0 || getPredinedDisableCustomNotifications.length > 0 ? true : false) || !isSiteTeamUsers()" :style="[!isSiteTeamUsers() ? { cursor: 'not-allowed' } : {}]" v-model="disableNotificationsFlag" v-on:change="disableNotifications()">Disable all notifications </b-form-checkbox>
            </b-col>
          </b-row>
          <div class="activitiesDiv">
            <div v-for="(notification, index) in notifications" class="pb-5" :key="index">
              <b-row>
                <b-col cols="7" class="p-0 ellipsisClass">
                  <b-form-checkbox :disabled="(getPredinedDisableTasks.length > 0 || getPredinedDisableCustomNotifications.length > 0 ? true : false) || !isSiteTeamUsers()" v-model="notification.active" @input="updateChangeStatus()" :style="[notification.active ? { color: '#b0bac9' } : {}, !isSiteTeamUsers ? { cursor: 'not-allowed' } : {}]" :title="notification.name">
                    {{ notification.name }}</b-form-checkbox
                  >
                </b-col>
                <b-col cols="5" class="pl-5 pr-5" v-if="notification.notificationScheduler.type === 'milestone'" :style="[notification.active ? { color: '#b0bac9' } : {}]">Milestone {{ notification.notificationScheduler.milestoneString }}</b-col>
                <b-col cols="5" class="pl-5 pr-5" v-if="notification.notificationScheduler.type === 'custom'" :style="[notification.active ? { color: '#b0bac9' } : {}]">
                  {{ notification.notificationScheduler.frequency.title }} (
                  <span v-for="(duration, index) in notification.notificationScheduler.duration" :key="index"
                    >{{ duration.startDay }}-<span v-if="duration.endDay !== null">{{ duration.endDay }}</span
                    ><span v-else> end of study</span><span v-if="notification.notificationScheduler.duration.length - 1 !== index">, </span></span
                  >)</b-col
                >
              </b-row>
            </div>
          </div>
        </div>
      </div>
      <div v-if="this.currentParticipantStatus === 'SCREENFAILED'" class="text-secondary mt-8 mb-6 m-4 p-0">
        <p class="participant-static-text">
          Participant has failed screening. You can select a reason for failure below or simply confirm to change status.
        </p>
        <b-row class="d-flex justify-content-center modal-title">
          <b-col cols="8">
            <b-form-checkbox-group v-model="screenFailureReasons" :options="secreenFailureOptions" value-field="value" text-field="text" name="flavour-2a" class="multi-reasons-list" stacked></b-form-checkbox-group>
            <b-form-textarea v-if="screenFailurecheckOtherReason" class="mt-20 mb-10" :class="checkTextArea" placeholder="Enter a reason for failure" rows="3" name="Other" maxlength="100" v-validate="'required|min:3|max:100'" v-model="otherScreenFailureReasons"> </b-form-textarea>
            <p v-show="errors.has('Other')" class="error">
              {{ errors.first("Other") }}
            </p>
          </b-col>
        </b-row>
      </div>
      <div v-if="this.currentParticipantStatus === 'DISQUALIFIED'">
        <b-form-select class="mt-20 mb-10" v-model="disqualifyReason">
          <option value="">Select a reason for disqualification</option>
          <option v-for="(disqualifyReasonObj, index) in disqualifyReasons" :value="disqualifyReasonObj.text" :key="index"> {{ disqualifyReasonObj.text }}</option>
        </b-form-select>
        <b-form-textarea v-if="disqualifyReason === 'Other'" placeholder="Enter reason for disqualifying" rows="3" v-model="otherDisqualifyReason"></b-form-textarea>
      </div>
      <div v-if="this.currentParticipantStatus === 'DISCONTINUED'">
        <b-dropdown id="participant-reasons" size="xs" variant="outline-secondary" class="status-reasons-dropdown mt-20 mb-10" menu-class="full-width" no-caret ref="participantReasons">
          <template slot="button-content">
            <span v-if="selectedDiscontinuedReasons && selectedDiscontinuedReasons.length === 1" class="selected-reasons">
              {{ selectedDiscontinuedReasons[0] }}
            </span>
            <span v-else-if="selectedDiscontinuedReasons && selectedDiscontinuedReasons.length > 0" class="selected-reasons"
              >Reasons Selected <span class="highlight ml-5">{{ selectedDiscontinuedReasons.length }}</span></span
            >

            <span v-else class="unselected-reason">Select a reason for discontinuation <span style="color:red; margin-top: -5px;">*</span></span>
          </template>
          <b-row>
            <b-colxx md="12" class="mt-1">
              <b-form-group>
                <b-form-checkbox-group v-model="selectedDiscontinuedReasons" stacked>
                  <b-form-checkbox v-for="d in discontinuedReasons" :key="d.text" :value="d.value" :title="d.value" @click.native.capture.stop>{{ d.value }}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-colxx>
          </b-row>
        </b-dropdown>
        <span :class="checkTextArea" v-if="checkOtherReason">
          <b-form-textarea class="mt-20 mb-10" placeholder="Enter other reason for discontinuation" rows="3" v-model="otherDiscontinuedReason" v-validate="'required|min:3|max:100'" name="Other" maxlength="100"> </b-form-textarea>
        </span>
        <p v-show="errors.has('Other')" class="text-danger">
          {{ errors.first("Other") }}
        </p>
      </div>
      <div>
        <b-btn class="mt-20 br-3 change-btn w-200 pull-right" size="md" variant="primary" v-if="currentParticipantStatus === 'ACTIVEWMODIFICATION' && !showActivities" @click="configureModifications('status')" :disabled="!this.selectedReason || (this.selectedReason === 'Other' && !otherReason)">Configure modifications </b-btn>
        <span class="float-right">
          <b-btn class="mt-20 br-3 mr-10 custom-cancel-button" size="md" variant="default" v-if="currentParticipantStatus === 'DISCONTINUED' && !hideChangeStatus" @click="cancelConfirmation()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 change-status-btn pull-right" size="md" variant="primary" v-if="(showActivities || currentParticipantStatus !== 'ACTIVEWMODIFICATION') && !hideChangeStatus && this.participantDetails.status !== 'SCREENPASSED' && hideChangeBtn" :disabled="getDisableChgStatus()" @click="changeStatus()">Change Status</b-btn>
        </span>
        <b-btn class="mt-20 br-3 change-btn cancel-button mr-10 pull-right" size="md" variant="primary" v-if="showActivities && !hideChangeStatus && participantDetails.status !== 'ACTIVEWMODIFICATION'" @click="showActivities = false">Back</b-btn>
        <b-btn class="mt-20 br-3 change-btn mr-10 cancel-button" size="md" variant="primary" v-if="hidechangeStatusActiveWithModifyUpdate" @click="cancelConfirmation()">Cancel</b-btn>
        <b-btn class="mt-20 br-3 change-btn pull-right" size="md" variant="primary" v-if="hidechangeStatusActiveWithModifyUpdate" @click="updateActivities()" :disabled="!isSiteTeamUsers()">Save changes</b-btn>
      </div>
      <div v-if="hideChangeStatus && currentParticipantStatus === 'WITHDRAWSTUDY'" style="text-align:center;">
        <div>Are you sure you want to withdraw this participant?</div>
        <div>This action cannot be undone.</div>
        <div>
          <b-btn class="mt-20 br-3 change-btn mr-10 cancel-button" size="md" variant="primary" @click="cancelConfirmation()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 change-btn" :disabled="yesConfirmBtnFlag" size="md" variant="primary" @click="withDrawParticipant()">Yes</b-btn>
        </div>
      </div>
      <div v-if="hideChangeStatus && (currentParticipantStatus === 'DISQUALIFIED' || currentParticipantStatus === 'DISCONTINUED' || currentParticipantStatus === 'ACTIVEWMODIFICATION' || currentParticipantStatus === 'SCREENPASSED' || currentParticipantStatus === 'SCREENFAILED' || currentParticipantStatus === 'ACTIVE' || currentParticipantStatus === 'ACTIVEWITHOUTAPP')" style="text-align:center;">
        <div>
          <div v-if="currentParticipantStatus === 'ACTIVEWITHOUTAPP'">
            Are you sure you want to activate this participant without inviting them to the app?
          </div>
          <div v-else>
            Are you sure you want to change the status of this participant?
          </div>
          <div>This action cannot be undone.</div>
        </div>
        <div>
          <b-btn class="mt-20 br-3 change-btn mr-10 cancel-button" size="md" variant="primary" @click="cancelConfirmation()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 change-btn" :disabled="yesConfirmBtnFlag" size="md" variant="primary" @click="confirmChangeStatus()">Yes</b-btn>
        </div>
      </div>
      <div v-if="this.participantDetails.status === 'SCREENPASSED'" style="text-align:center;">
        <div>Participant has passed screening</div>
        <div>Do you want to send an invite?</div>
        <div>
          <b-btn class="mt-20 br-3 change-btn mr-10 cancel-button" size="md" variant="primary" @click="$refs.editParticipantStatusModal.hide()">Invite later</b-btn>
          <b-btn class="mt-20 br-3 change-btn" size="md" variant="primary" @click="invite()">Invite Now</b-btn>
        </div>
      </div>
    </b-modal>
    <user-verification-modal ref="userVerificationModal" :userDetails="userDetailsObj" />
    <user-confirmation-modal ref="userConfirmationModal" />

    <div class="modal fade siteIdModel-2" v-if="participantDetailsCustomFileds" id="participantDetailsCustomFileds" tabindex="-1" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" :class="{ verifyPhone: isVerificationModal }">
        <div class="modal-content">
          <div class="modal-header">
            <h5>
              Change
              {{ participantInfo.customFields[oIndex]["registrationCustomFieldName" + iIndex] }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="cancelParticipant()">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <input v-model="participantInfo.customFields[oIndex]['registrationCustomFieldValue' + iIndex]" type="text" class="form-control py-2 my-2" placeholder="" maxlength="60" />
            </div>
            <div class="d-flex pt-28 justify-content-center">
              <div>
                <button type="button" class="btn btn-1 fs-14  mr-22" data-dismiss="modal" @click="cancelCustomFieldValue()">
                  Cancel
                </button>
              </div>
              <div>
                <button type="button" @click="updateCustomFieldValue()" class="btn btn-2 fs-14" :disabled="participantModifyValue == 'verificationPhone' && isVerificationPhone && isDuplicateOrInvalidNumber">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" ref="editEmailModal" class="edit-email-modal" hide-footer hide-header body-class="pt-0">
      <div>
        <img alt="img" class="close-icon" src="static/img/close-new.svg" @click="$refs.editEmailModal.hide()" style="cursor:pointer" />
      </div>
      <div class="clearfix"></div>
      <div>
        <div class="modal-title">
          <b
            ><p class="fs-18 pl-10 pr-10" style="color:#666669">
              Edit Email
            </p></b
          >
        </div>
        <b-row class="rowDiv pt-10 pb-10 pr-10">
          <b-col cols="4">
            <div class="subHeading pb-5">Participant ID</div>
            <div class="word-break" style="color:#4a4a4a;">
              {{ participantDetails.userDefinedParticipantId }}
            </div>
          </b-col>
          <b-col cols="8">
            <div class="subHeading pb-5">THREAD ID</div>
            <div class="word-break" style="color:#4a4a4a;">
              {{ participantDetails.id }}
            </div>
          </b-col>
        </b-row>
        <div class="pt-20">
          <b-col cols="12" class="p-0">
            <input type="text" class="form-control highlighted" v-model="newEmailId" placeholder="Enter new email" v-validate="'required|email'" name="participantNewEmail" />
            <div class="error-style" v-if="errors.has('participantNewEmail')">
              {{ errors.first("participantNewEmail") }}
            </div>
          </b-col>
        </div>
        <div>
          <b-form-select class="mt-20 mb-10" v-model="selectedReasonForEmailChange" @change="emailReasonChange($event)">
            <option value="" disabled selected>Select a reason for the change</option>
            <option v-for="(reason, index) in emailChangeReasons" :value="reason.value" :key="index">{{ reason.name }}</option>
          </b-form-select>
          <b-form-textarea v-show="selectedReasonForEmailChange === 'Other'" placeholder="Enter a reason for change." rows="3" v-model="reasonForEmailChangeEntered" v-validate="'required|min:5|max:100'" name="participantEmailChangeReason" maxlength="100"></b-form-textarea>
          <div class="error-style" v-if="selectedReasonForEmailChange === 'Other' && errors.has('participantEmailChangeReason')">
            {{ errors.first("participantEmailChangeReason") }}
          </div>
        </div>
        <b-col cols="12" class="text-right pr-0">
          <b-btn class="mt-20 mr-10 br-3 cancel-btn" size="md" variant="default" @click="$refs.editEmailModal.hide()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 update-btn mr-0" size="md" variant="primary" :disabled="shouldDisableUpdateButton" @click="confirmUpdateEmailId()">Update</b-btn>
        </b-col>
      </div>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" ref="duplicateEmailModal" class="duplicate-email-modal" hide-footer hide-header body-class="p-20">
      <div>
        <div class="modal-title text-center">
          <b
            ><p class="fs-20 mb-0">
              This email address is already registered.
            </p></b
          >
        </div>
        <div class="pt-20 text-center">
          <p>
            Please be advised if you continue with this edit you will have more than one participant in this study with this email address.
          </p>
          <p>Would you like to continue?</p>
        </div>
        <b-col cols="12" class="text-center">
          <b-btn class="mt-20 mr-10 br-3 cancel-btn" size="md" variant="default" @click="$refs.duplicateEmailModal.hide()">Cancel</b-btn>
          <b-btn class="mt-20 br-3 yes-btn" size="md" variant="primary" :disabled="false" @click="updateEmailId('true')">Yes</b-btn>
        </b-col>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import * as utils from "@/services/visualization/utils";
import { participantStatusesText, participantSourcesText } from "@/constants/authRoles";
import otpInputService from "../services/otp-input-service";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import $ from "jquery";
import * as constant from "../../constants/config";
import cloneDeep from "lodash/cloneDeep";
import UserVerificationModal from "@/components/modals/user-verification-modal";
import UserConfirmationModal from "@/components/modals/user-confirmation-modal";
import UserAccesses from "@/mixins/user-accesses";
import ParticipantFormStatus from "@/mixins/participant-form-status";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import localStorageService from "@/services/localStorage";
const dict = {
  custom: {
    participantNewEmail: {
      required: "Email is required.",
      email: "Please enter a valid email address."
    },
    participantEmailChangeReason: {
      required: "Please specify a reason for change.",
      min: "Please add more details."
    }
  }
};

export default {
  name: "PiiAndNonPiiInfo",
  components: {
    otpInputService,
    UserVerificationModal,
    UserConfirmationModal,
    DatePicker
  },
  mixins: [UserAccesses, ParticipantFormStatus],
  created() {
    if (constant.SCREENWIDTH > 1200) {
      this.displayMobileView = false;
    } else {
      this.displayMobileView = true;
    }
  },
  props: {
    participantDetails: {
      type: Object
    },
    studyResponse: {
      type: Object
    },
    studyData: {
      type: Object
    },
    isDataLoadingFinishFlag: {
      type: Boolean
    },
    userData: {
      type: Object,
      default: () => {}
    },
    approvalStatusTextUpdated: {
      type: Object,
      default: () => {}
    },
    reviewedStatusTextUpdated: {
      type: Object,
      default: () => {}
    },
    verifiedStatusTextUpdated: {
      type: Object,
      default: () => {}
    },
    lockedStatusTextUpdated: {
      type: Object,
      default: () => {}
    },
    signedoffStatusTextUpdated: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showDOB: false,
      showDobWithMonthYear: false,
      showDobWithYear: false,
      researchSites: null,
      isSiteDetailsLoaded: false,
      isExpand: false,
      siteSelected: false,
      studyId: this.$route.params.studyId,
      participantId: this.$route.params.participantId,
      participantModifyValue: "",
      phoneObject: { valid: false },
      contactPhoneObject: null,
      contactPhone: "",
      contactPhoneCountryCode: this.preferredCountries ? this.preferredCountries[0] : "+1",
      verificationPhone: "",
      verificationPhoneCountryCode: this.preferredCountries ? this.preferredCountries[0] : "+1",
      defaultCountry: "US",
      preferredCountries: ["US"],
      isVerificationModal: false,
      gender: [],
      ageRange: [],
      howDidYouHear: ["Facebook", "Twitter", "Snapchat", "Other Social Media", "Blog", "Google Search", "Apple App Store", "Google Play Store"],
      discontinuedReasons: [],
      disqualifyReasons: [],
      otherDiscontinuedReason: "",
      selectedDiscontinuedReasons: [],
      userDefinedParticipantId: this.participantDetails.userDefinedParticipantId,
      participantInfo: "",
      isDataLoadingFinish: false,
      reasonForChange: null,
      isSaveBtnDisabled: true,
      participantIDdisabled: false,
      hasError: {
        idErrorMsg: null,
        reasonErrorMsg: null
      },
      noCloseOnBackdrop: true,
      formattingArray: [],
      userDefinedArray: [],
      fixedCharactersIndex: [],
      participantDetailsModifyModal: false,
      isParticipantEditModalBoxVisible: false,
      noCloseOnOutsideClick: true,
      participantStatusesText,
      isAvailableHistory: false,
      reasons: [
        {
          name: "Discontinued study drug",
          value: "Discontinued study drug"
        },
        {
          name: "Post study follow-up",
          value: "Post study follow-up"
        },
        {
          name: "Other",
          value: "Other"
        }
      ],
      newParticipantStatus: " ",
      userReasonForOther: "",
      selectedReason: "",
      tasks: [],
      notifications: [],
      showActivities: false,
      otherReason: "",
      disableActivitiesFlag: false,
      disableNotificationsFlag: false,
      statuses: [],
      currentParticipantStatus: " ",
      hideChangeStatus: false,
      showDisqualify: false,
      disqualifyReason: "",
      otherDisqualifyReason: "",
      disableChangeStatus: true,
      participantSourcesText,
      feature: [],
      disableStatusEdit: false,
      isFormatUpdate: null,
      getPredinedDisableTasks: [],
      getPredinedDisableCustomNotifications: [],
      showActivitiesNotifications: true,
      withModificationsLinkClickFlg: false,
      hideChangeBtn: true,
      disabledFlag: true,
      modifyclickFlg: false,
      yesConfirmBtnFlag: false,
      hidechangeStatusActiveWithModifyUpdate: false,
      searchedSite: "",
      newSiteTransferReason: "",
      isSiteTransferReason: false,
      newSite: "",
      transferHistory: [],
      listOfSiteTransferReason: [
        {
          name: "Site Closing",
          value: "Site Closing"
        },
        {
          name: "Participant Relocation",
          value: "Participant Relocation"
        },
        {
          name: "Other",
          value: "Other"
        }
      ],
      participantInfoData: [],
      userAuthModal: null,
      isDropDownShow: false,
      selectedCurrentStatus: "",
      legacyVal: true,
      participantStatuses: [],
      oIndex: 0,
      iIndex: 0,
      participantDetailsCustomFileds: false,
      newEmailId: this.participantDetails.email,
      reasonForEmailChangeEntered: null,
      emailChangeReasons: [
        {
          name: "Entry Error",
          value: "Entry Error"
        },
        {
          name: "Participant Request",
          value: "Participant Request"
        },
        {
          name: "Other",
          value: "Other"
        }
      ],
      selectedReasonForEmailChange: "",
      userDetailsObj: null,
      screenFailureReasons: [],
      otherScreenFailureReasons: "",
      secreenFailureOptions: [
        {
          text: "Participant has not met the inclusion criteria",
          value: "Participant has not met the inclusion criteria"
        },
        {
          text: "Participant has met the exclusion criteria",
          value: "Participant has met the exclusion criteria"
        },
        {
          text: "Participant withdrew consent",
          value: "Participant withdrew consent"
        },
        {
          text: "Other",
          value: "Other"
        }
      ],
      userDetails: this.userData,
      removeActivityEditIcon: false,
      approvalStatusTextSetNewStatus: "",
      approvedFlageValue: false,
      verifiedStatusTextNewStatus: "",
      verifiedFlageValue: false,
      reviewedStatusTextNewStatus: "",
      reviewedFlageValue: false,
      verifiedStatusTextNewStatus: "",
      verifiedFlageValue: false,
      lockedStatusTextNewStatus: "",
      lockedFlageValue: false,
      signedOffStatusTextNewStatus: "",
      signedOffFlageValue: false,
    };
  },
  computed: {
    ...mapGetters(["token", "user"]),
    //TUR-61129
    verificationPhoneCountry() {
      return this.defaultCountry;
    },
    isOpenEnrollment() {
      return !(this.studyData && this.studyData.onboardingType && this.studyData.onboardingType != "OpenEnrollment");
    },
    isVerificationPhone() {
      return !!(this.participantDetails != null && this.participantDetails.verificationMethod && this.participantDetails.verificationMethod === "phone");
    },
    isStudyVerificationPhoneVisible() {
      return !!(this.studyData != null && this.studyData.verificationMethod && this.studyData.verificationMethod !== "email");
    },
    isVerificationPhoneAccess() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canCallCenterAccess || this.canSiteDataLockAccess;
    },
    isSameContactNumber() {
      const contactPhone = this.$options.filters.e164(this.participantInfo.phoneNumber, this.participantInfo.countryCode, this.participantInfo.smsCountryIsoName);
      return contactPhone == (this.contactPhoneObject && this.contactPhoneObject.number ? this.contactPhoneObject.number.e164 : "");
    },
    isSameVerificationNumber() {
      const verificationPhone = this.$options.filters.e164(this.participantDetails.mobile, this.participantDetails.mobileCountryCode);
      return verificationPhone == (this.phoneObject && this.phoneObject.number ? this.phoneObject.number.e164 : "");
    },
    isDisabled() {
      return (this.participantModifyValue == "verificationPhone" && this.phoneObject && (!this.phoneObject.valid || this.isSameVerificationNumber)) || (this.participantModifyValue == "Phone" && this.contactPhoneObject && (!this.contactPhoneObject.valid || this.isSameContactNumber));
    },
    //TUR-61129
    participantStatus() {
      if (this.participantDetails && this.participantDetails.status == undefined) {
        return;
      }
      return this.participantStatusesText[this.participantDetails.status];
    },
    isThirdRowCanBeAcessiable() {
      return this.participantDetails.phoneNumber == undefined && this.participantDetails.nonMobilePhoneNumber == undefined && this.participantDetails.source === undefined && this.participantDetails.howDidYouHear == undefined;
    },
    isFirstRowCanBeAcessiable() {
      return (
        this.participantDetails.email == undefined &&
        this.participantDetails.parentOrCgFirstName == undefined &&
        this.participantDetails.parentOrCgLastName == undefined &&
        this.participantDetails.participantLanguage &&
        this.participantDetails.participantLanguage.display_name == undefined &&
        this.participantDetails.countryName == undefined &&
        this.participantDetails.participantUsedDevices == undefined
      );
    },
    isSecondRowCanBeAcessiable() {
      return this.participantDetails.address == undefined && this.participantDetails.city == undefined && this.participantDetails.state == undefined && this.participantDetails.country == undefined && this.participantDetails.zipcode == undefined;
    },
    searchedSitesList() {
      if (!this.studyResponse.sitesInfo) {
        return [];
      }
      if (!this.studyResponse.sitesInfo.length) {
        return [];
      }
      let sitesInfoArr = this.studyResponse.sitesInfo.filter(site => site.name.toLowerCase().includes(this.searchedSite.trim().toLowerCase()) || site.userSiteId.toLowerCase().includes(this.searchedSite.trim().toLowerCase()));
      sitesInfoArr = sitesInfoArr.filter(data => data.id != this.participantDetails.siteId);
      return sitesInfoArr;
    },
    statusOptions() {
      const statuses = this.getStatuses();
      if (statuses && this.canHomeHealthAccess) {
        return statuses.filter(status => status.value != "WITHDRAWSTUDY");
      } else {
        return statuses;
      }
    },
    checkOtherReason() {
      return this.selectedDiscontinuedReasons.includes("Other");
    },
    screenFailurecheckOtherReason() {
      return this.screenFailureReasons.includes("Other");
    },
    checkTextArea() {
      return this.otherDiscontinuedReason.length < 1 || this.otherScreenFailureReasons.length < 1 ? "input-text-area-other input-group-other" : "input-group-other";
    },
    shouldDisableUpdateButton() {
      return this.$validator.errors.has("participantNewEmail") || (this.selectedReasonForEmailChange == "Other" && this.$validator.errors.has("participantEmailChangeReason")) || this.selectedReasonForEmailChange == "" || this.newEmailId == this.participantDetails.email;
    }
  },
  watch: {
    newSiteTransferReason() {
      this.newSiteTransferReason;
    },
    isExpand(v) {
      this.$emit("expanded", v);
    },
    participantDetails: {
      handler() {
        this.isExpand = this.isExpand ? this.isExpand : false;
        this.isDataLoadingFinish = true;
        this.checkIfParticipantIdFormatHasBeenChanged();
      }
    },
    studyResponse: {
      handler(val) {
        if (val) {
          this.initializeOtpInput();
        }
      }
    },
    userData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.userDetailsObj = newVal;
        }
      }
    },
    approvalStatusTextUpdated: {
      handler(newVal) {
        if (newVal) {
          this.approvalStatusTextSetNewStatus = newVal.siteFormStatus.toLowerCase() == "approved" ? "Approved" : "Unapproved";
          this.approvedFlageValue = newVal.approvedFlage;
        }
      }
    },
    reviewedStatusTextUpdated: {
      handler(newVal) {
        if (newVal) {
          this.reviewedStatusTextNewStatus = newVal.siteFormStatus.toLowerCase() == "reviewed" ? "Reviewed" : "Unreviewed";
          this.reviewedFlageValue = newVal.reviewedFlage;
        }
      }
    },
    verifiedStatusTextUpdated: {
      handler(newVal) {
        if (newVal) {
          this.verifiedStatusTextNewStatus = newVal.siteFormStatus.toLowerCase() == "verified" ? "Verified" : "Unverified";
          this.verifiedFlageValue = newVal.verifyFlage;
        }
      }
    },
    lockedStatusTextUpdated: {
      handler(newVal) {
        if (newVal) {
          this.lockedStatusTextNewStatus = newVal.siteFormStatus.toLowerCase() == "locked" ? "Locked" : "Unlocked";
          this.lockedFlageValue = newVal.lockedFlage;
        }
      }
    },
    signedoffStatusTextUpdated: {
      handler(newVal) {
        if (newVal) {
          this.signedOffStatusTextNewStatus = newVal.siteFormStatus.toLowerCase() == "signedoff" ? "Signed off" : newVal.siteFormStatus.toLowerCase() == "pending" ? "Unsigned off" : "Unsigned off";
          this.signedOffFlageValue = newVal.signedOffFlage;
        }
      }
    }
  },
  methods: {
    //TUR-61129
    setDefaultCountryDropdown() {
      if (this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator" || this.user.userRole == "HomeHealth" || this.user.userRole == "SiteDataLock" || this.user.userRole == "Rater" || this.user.userRole == "Interviewer" || this.user.userRole == "CallCenter") {
        this.getSiteDetailsFact();
      } else {
        this.getSiteDetails();
      }
    },
    getSiteDetailsFact() {
      if (this.user.siteIds) {
        this.$api.getSiteDetailsFact(this.studyId, this.user.siteIds[0]).then(
          response => {
            this.researchSites = response.body;
            this.setPreferredCountries();
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the site details.");
          }
        );
      }
    },
    getSiteDetails() {
      this.$api.getSitesFact(this.studyId).then(
        response => {
          this.researchSites = response.body;
          this.setPreferredCountries();
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the list of sites.");
        }
      );
    },
    setPreferredCountries() {
      if (this.researchSites && !this.researchSites.length) {
        const tempArr = [];
        tempArr.push(this.researchSites);
        this.researchSites = tempArr;
      }
      const allSitesCountries = this.researchSites && this.researchSites.length > 0 ? this.researchSites.filter(rs => rs.status == "Active").map(s => s.countryList) : null;
      if (allSitesCountries && allSitesCountries.length > 0) {
        const countriesSet = new Set();
        allSitesCountries.forEach(country => {
          country.forEach(countryCode => {
            if (countryCode) {
              countriesSet.add(countryCode.isoCode2);
            }
          });
        });
        this.preferredCountries = Array.from(countriesSet);
        this.preferredCountries.sort();
        this.contactPhoneCountryCode = this.participantInfo.countryCode ? this.participantInfo.countryCode.replace("+", "") : this.preferredCountries[0];
        this.verificationPhoneCountryCode = this.participantDetails.mobileCountryCode ? this.participantDetails.mobileCountryCode.replace("+", "") : this.preferredCountries[0];
        this.isSiteDetailsLoaded = true;
      }
    },
    onInputVerificationPhoneNumber(phoneObject) {
      this.phoneObject = phoneObject;
    },
    countryChanged() {
      this.phoneValidated(this.phoneObject);
    },
    phoneValidated(phoneObject) {
      this.phoneObject = phoneObject;
      if (this.phoneObject.valid) {
        this.verificationPhone = this.$options.filters.trim0(this.phoneObject.number.national);
      }
    },
    onPhoneValidated(phoneObject) {
      this.phoneObject = phoneObject;
      setTimeout(() => {
        const vuetel = this.$refs.verificationPhone.$el;
        const vuetelInp = $(vuetel).find("input")[0];
        if (this.phoneObject && this.phoneObject.number && this.phoneObject.valid && this.phoneObject.number.national && this.phoneObject.number.national.charAt(0) == "0") {
          vuetelInp.value = this.phoneObject.number.national.substring(1);
        }
      }, 1000);
    },
    onInputContactPhoneNumber(phoneObject) {
      this.contactPhoneObject = phoneObject;
    },
    contactCountryChanged() {
      this.contactPhoneValidated(this.contactPhoneObject);
    },
    contactPhoneValidated(phoneObject) {
      this.contactPhoneObject = phoneObject;
      if (this.contactPhoneObject.valid) {
        this.contactPhone = this.$options.filters.trim0(this.contactPhoneObject.number.national);
      }
    },
    contactOnPhoneValidated(phoneObject) {
      this.contactPhoneObject = phoneObject;
      setTimeout(() => {
        const vuetel = this.$refs.contactPhoneNumber.$el;
        const vuetelInp = $(vuetel).find("input")[0];
        if (this.contactPhoneObject && this.contactPhoneObject.number && this.contactPhoneObject.number.national && this.contactPhoneObject.number.national.charAt(0) == "0") {
          vuetelInp.value = this.contactPhoneObject.number.national.substring(1);
        }
      }, 1000);
    },
    modifyVerificationText(method) {
      if (method === "phone") {
        return "Phone";
      } else {
        return "Email";
      }
    },
    //TUR-61129
    getCohortName(segmentId) {
      if (!!segmentId == false || !!this.studyData.segments == false || segmentId.toLowerCase() == "pending") {
        return "Pending";
      }
      const pendingCohort = this.studyData.segments.find(field => {
        return field.id == segmentId;
      });
      return pendingCohort ? pendingCohort.name : "Pending";
    },
    cancelParticipant() {
      this.$emit("getParticipantInformation");
    },
    rolesAccessPermissions() {
      if (this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator") {
        return true;
      } else {
        return false;
      }
    },
    updateParticpantValue() {
      const updatedval = this.participantInfo;
      let emailValidation = false;
      let phoneNumbervalidation = false;
      let verificationPhoneNumberValidation = false;
      if (this.participantModifyValue == "email") {
        const mailformat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (updatedval.email.match(mailformat)) {
          emailValidation = true;
        }
      }
      if (this.participantModifyValue == "Phone") {
        this.participantInfo.phoneNumber = this.contactPhoneObject.number.significant;
        this.participantInfo.smsCountryIsoName = this.contactPhoneObject.country.iso2;
        this.participantInfo.countryCode = "+" + this.contactPhoneObject.country.dialCode;
        phoneNumbervalidation = this.contactPhoneObject.valid;
      }
      if (this.participantModifyValue == "verificationPhone") {
        if (this.phoneObject && this.phoneObject.isValid === true) {
          verificationPhoneNumberValidation = true;
        } else {
          verificationPhoneNumberValidation = false;
        }
      }
      if (this.participantModifyValue == "email" && !emailValidation) {
        this.$toastr.error("Enter Valid Email Id.");
      } else if (this.participantModifyValue == "Phone" && !phoneNumbervalidation) {
        this.$toastr.error("Enter Valid Phone Number.");
      } else if (this.participantModifyValue == "verificationPhone" && !verificationPhoneNumberValidation) {
        this.$toastr.error("Enter Valid Verification Phone Number.");
      } else {
        this.participantInfo = cloneDeep(this.participantInfo);
        this.participantInfo.participantLocalTime = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ");
        const payload = {
          studyId: this.studyId,
          participantId: this.participantInfo.id,
          data: updatedval
        };
        if (this.participantModifyValue == "verificationPhone") {
          const { dialCode } = this.phoneObject.country || this.phoneObject;
          const { significant } = this.phoneObject.number;
          const verificationPhonePayload = {
            studyId: this.studyId,
            participantId: this.participantDetails.id,
            isPhone: true,
            data: {
              mobile: significant,
              mobileCountryCode: "+" + dialCode,
              mobileIso3: this.phoneObject.country.iso2
            }
          };
          const payload = {
            mobile: significant,
            countryCode: "+" + dialCode,
            username: this.participantDetails.cognitoUserName,
            languageId: this.participantDetails.participantLanguage && this.participantDetails.participantLanguage.language_id
          };
          this.$api
            .updateParticipantIdFact(verificationPhonePayload)
            .then(response => response)
            .then(response => {
              this.verificationPhone = response.data.mobile;
              this.participantDetails.mobile = response.data.mobile;
              this.participantDetails.mobileCountryCode = "+" + this.phoneObject.country.dialCode;
              if (this.participantDetails && this.participantDetails.cognitoUserName) {
                this.$api
                  .updateCognitoPhoneNo(payload)
                  .then(() => {
                    window.$("#participantDetailsModifyModal").modal("hide");
                    this.participantDetailsModifyModal = false;
                    this.$toastr.success("Profile updated successfully.");
                  })
                  .catch(error => {
                    this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the participant verification phone no.");
                  });
              } else {
                window.$("#participantDetailsModifyModal").modal("hide");
                this.participantDetailsModifyModal = false;
                this.$toastr.success("Profile updated successfully.");
              }
            })
            .catch(error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the participant verification phone no.");
            });
        } else {
          if (this.participantInfo.dob) {
            payload.data.dob = moment(payload.data.dob).format("YYYY-MM-DD");
          }
          if (this.participantInfo.dobWithMonthYear) {
            payload.data.dobWithMonthYear = moment(payload.data.dobWithMonthYear).format("YYYY-MM");
          }
          if (this.participantInfo.dobWithYear) {
            payload.data.dobWithYear = moment(payload.data.dobWithYear).format("YYYY");
          }
          let dates = [];
          if (this.participantInfo.dob || this.participantInfo.dobWithMonthYear || this.participantInfo.dobWithYear) {
            if (this.participantInfo.dob) {
              const dob = moment(payload.data.dob).format("YYYY-MM-DD");
              dates = dob.split("-");
            }
            if (this.participantInfo.dobWithMonthYear) {
              const dobWithMonthYear = moment(payload.data.dobWithMonthYear).format("YYYY-MM-DD");
              dates = dobWithMonthYear.split("-");
            }
            if (this.participantInfo.dobWithYear) {
              const dobWithYear = moment(payload.data.dobWithYear).format("YYYY-MM-DD");
              dates = dobWithYear.split("-");
            }
          }
          payload.data.dobDay = dates[2] && payload.data.dobFormat == "MDY" ? dates[2] : null;
          payload.data.dobMonth = dates[1] && (payload.data.dobFormat == "MDY" || payload.data.dobFormat == "MY") ? dates[1] : null;
          payload.data.dobYear = dates[0] && (payload.data.dobFormat == "MDY" || payload.data.dobFormat == "MY" || payload.data.dobFormat == "Y") ? dates[0] : null;
          if (payload && payload.data && payload.data.status && payload.data.status == "ACTIVEWMODIFICATION") {
            const selectedTasks = this.tasks.filter(task => task.active === true);
            const selectedNotifications = this.notifications.filter(notification => notification.active === true);
            const participantDisableConfigDTO = {};
            participantDisableConfigDTO.tasks = selectedTasks;
            participantDisableConfigDTO.customNotifications = selectedNotifications;
            payload.data["participantDisableConfigDTO"] = participantDisableConfigDTO;
          }     
          this.$api.updateParticipantInfoFact(payload).then(
            response => {
              window.$("#participantDetailsModifyModal").modal("hide");
              this.participantDetailsModifyModal = false;
              const _this = this;
              setTimeout(function() {
                _this.$emit("getParticipantInformation");
                _this.$toastr.success(response.bodyText);
              }, 1500);
            },
            error => {
              this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating Participant Info.");
            }
          );
        }
      }
    },
    editenabledfield(type) {
      this.participantInfo = { ...this.participantDetails };
      if (type === "Phone") {
        //TUR-61129
        this.contactPhone = this.$options.filters.e164(this.participantInfo.phoneNumber, this.participantInfo.countryCode, this.participantInfo.smsCountryIsoName);
        this.contactPhoneCountryCode = this.participantInfo && this.participantInfo.countryCode ? this.participantInfo.countryCode.replace("+", "") : "";
      }
      //TUR-61129
      if (type === "verificationPhone") {
        this.isVerificationModal = true;
        this.verificationPhone = this.$options.filters.e164(this.participantDetails.mobile, this.participantDetails.mobileCountryCode);
        this.verificationPhoneCountryCode = this.participantDetails && this.participantDetails.mobileCountryCode ? this.participantDetails.mobileCountryCode.replace("+", "") : "";
      }
      //TUR-61129
      this.participantModifyValue = type;
      if (this.participantInfo.dob) {
        this.participantInfo.dob = new Date(this.participantInfo.dob);
      }
      if (this.participantInfo.dobWithMonthYear) {
        this.participantInfo.dobWithMonthYear = new Date(this.participantInfo.dobWithMonthYear);
      }
      if (this.participantInfo.dobWithYear) {
        this.participantInfo.dobWithYear = new Date(this.participantInfo.dobWithYear);
      }
      this.getParticipantLookUpDropdataList();
      this.participantDetailsModifyModal = true;
      if (this.participantInfo && this.participantInfo.status == "ACTIVEWMODIFICATION") {
        this.configureModifications("ACTIVEWMODIFICATION");
      }
    },
    showSiteTransferReason() {
      this.isSiteTransferReason = !this.isSiteTransferReason;
    },
    checkAllConditions() {
      if ((this.newSiteTransferReason !== "Other" && this.newSiteTransferReason && this.siteSelected) || (this.newSiteTransferReason === "Other" && this.newSiteTransferReason && this.siteSelected && this.userReasonForOther)) {
        return true;
      }
    },
    onSiteTransferReasonClick(IP) {
      this.newSiteTransferReason = IP;
      const v = document.getElementById("showSiteTransferReason");
      v.style.display = "none";
    },
    sendSiteDataToTransfer() {
      const dataOBj = {
        participantIds: [this.participantDetails.id],
        userRole: this.user.userRole,
        fromSiteId: this.participantDetails.siteId,
        toSiteId: this.newSite.id,
        reason: this.newSiteTransferReason,
        createdBy: this.participantDetails.firstName
      };

      if (this.newSiteTransferReason == "Other") {
        dataOBj.reason = this.userReasonForOther;
      }
      if (this.user.userRole == "SystemAdmin" || this.user.userRole == "StudyAdmin" || this.user.userRole == "Pi" || this.user.userRole == "SubPi" || this.user.userRole == "StudyCoordinator") {
        this.$api.participantsSiteTransferID(this.studyId, dataOBj).then(
          () => {
            window.$("#confirmTransferModal").modal("hide");
            this.$toastr.success("Transfer request has been sent.");
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving modifications.");
          }
        );
      } else {
        this.$toastr.error(`This role doesn't have access to transfer participant to another site`);
      }
    },
    dropNewSiteData() {
      this.newSite = "";
      this.newSiteTransferReason = "";
    },
    expandSection() {
      this.isExpand = !this.isExpand;
    },
    canAccessDisqulifyBtn() {
      return this.participantDetails.status === "ACTIVE" || this.participantDetails.status === "VERIFIED" || this.participantDetails.status === "INVITED" || this.participantDetails.status === "NOTINVITED" || this.participantDetails.status === "ACTIVEWITHOUTAPP";
    },
    canEditStatus() {
      return this.participantDetails.status === "ACTIVE" || this.participantDetails.status === "ACTIVEWMODIFICATION" || this.participantDetails.status === "VERIFIED" || this.participantDetails.status === "INVITED" || this.participantDetails.status === "NOTINVITED" || this.participantDetails.status === "SCREENING" || this.participantDetails.status === "ACTIVEWITHOUTAPP";
      // this.participantDetails.status === 'PRESCREENED' ||
      // this.participantDetails.status === 'SCREENPASSED' ;
    },
    canEditEmailId() {
      return (this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess) && !this.user.readOnly;
    },
    disqualifyParticipant() {
      const dataObj = {
        studyId: this.studyId,
        status: "DISQUALIFIED",
        disqualifyReason: "",
        email: this.participantDetails && this.participantDetails.email ? this.participantDetails.email : null,
        id: this.participantDetails && this.participantDetails.id,
        siteId: this.participantDetails.siteId,
        countryId: this.participantDetails.countryId,
        participantLanguage: this.participantDetails.participantLanguage
      };
      if (this.disqualifyReason === "" || (this.disqualifyReason === "Other" && !this.otherDisqualifyReason)) {
        this.$toastr.error("Please select a reason for disqualifying the participant.");
      } else {
        if (this.disqualifyReason === "Other") {
          dataObj.disqualifyReason = this.otherDisqualifyReason;
        } else {
          dataObj.disqualifyReason = this.disqualifyReason;
        }
        this.$api.disqualifyFact(dataObj.id, this.studyId, dataObj).then(
          response => {
            this.$refs.editParticipantStatusModal.hide();
            this.$toastr.success(response.bodyText);
            this.$router.push({
              name: "study-participants-list",
              params: {
                studyId: this.studyId
              }
            });
            this.visitDetails = {};
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while disqualifying participant.");
          }
        );
      }
    },
    discontinueParticipant() {
      const dataObj = {
        studyId: this.studyId,
        status: "DISCONTINUED",
        email: this.participantDetails && this.participantDetails.email ? this.participantDetails.email : null,
        id: this.participantDetails && this.participantDetails.id,
        siteId: this.participantDetails.siteId,
        countryId: this.participantDetails.countryId,
        participantLanguage: this.participantDetails.participantLanguage,
        discontinuedReasons: {}
      };
      if (this.checkDiscontinuedReasons()) {
        this.$toastr.error("Please select a reason for discontinued the participant.");
      } else {
        dataObj.disqualifyReason = this.disqualifyReason;
        const selectedDiscontinuedReasons = this.selectedDiscontinuedReasons.length > 0 ? this.selectedDiscontinuedReasons.filter(e => e != "Other") : [];
        dataObj.discontinuedReasons.reasons = selectedDiscontinuedReasons;
        if (this.checkOtherReason) {
          dataObj.discontinuedReasons.other = this.otherDiscontinuedReason;
        }
        this.$api.disqualifyFact(dataObj.id, this.studyId, dataObj).then(
          response => {
            this.$refs.editParticipantStatusModal.hide();
            this.$toastr.success(response.bodyText);
            this.$router.push({
              name: "study-participants-list",
              params: {
                studyId: this.studyId
              }
            });
            this.visitDetails = {};
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while discontinuing participant.");
          }
        );
      }
    },
    openEditModal() {
      this.$emit("getParticipantInformation");
      this.participantIDdisabled = false;
      this.userDefinedParticipantId = this.participantDetails.userDefinedParticipantId;
      this.isParticipantEditModalBoxVisible = true;
    },
    cancelEdit() {
      this.isParticipantEditModalBoxVisible = false;
    },
    updateParticipantID() {
      if (this.participantDetails.userDefinedParticipantId && this.participantDetails.status != "NOTINVITED") {
        if (this.reasonForChange == null || this.reasonForChange == "") {
          this.hasError.reasonErrorMsg = "Please specify the reason for change.";
        }
      }
      if (this.hasError.reasonErrorMsg != null) {
        return;
      }
      if (this.studyResponse.participantIdFormatConfigured.isFormattingChecked) {
        this.processTheParticipantId();
      }
      // userDefinedParticipantId will be null only when the formatting is set and participant  id is not requried.
      const dataObj = {};
      const userDefinedId = this.userDefinedParticipantId == null ? "" : this.userDefinedParticipantId.trim();
      if (this.reasonForChange != null) {
        dataObj.siteId = this.participantDetails.siteId;
        dataObj.reasonComment = this.reasonForChange;
        dataObj.newUserDefinedParticipantId = userDefinedId;
        dataObj.oldUserDefinedParticipantId = this.participantDetails.userDefinedParticipantId;
        dataObj.threadParticipantId = this.participantDetails.id;
        if (this.participantDetails.version) {
          dataObj.version = this.participantDetails.version;
        }
      } else {
        dataObj.studyId = this.studyId;
        dataObj.participantId = this.participantDetails.id;
        dataObj.data = { userDefinedParticipantId: userDefinedId };
      }
      if (!this.studyResponse.isParticipantIdEditable) {
        this.saveParticipantId(dataObj);
        return;
      }
      const self = this;
      this.$swal({
        title: "Are you sure you want to change the PID for this participant?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (self.studyResponse.allowDuplicatePid) {
            self
              .$swal({
                title: "This Participant ID is currently in use. If you choose to proceed, this PID will be assigned to more than one participant. Would you like to proceed?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#4a4a4a",
                cancelButtonColor: "#1e8fe1",
                confirmButtonText: "Cancel",
                cancelButtonText: "Yes"
              })
              .then(({ dismiss }) => {
                if (dismiss === "cancel") {
                  this.isParticipantEditModalBoxVisible = false;
                  this.isSaveBtnDisabled = true;
                  this.initializeOtpInput();
                  this.saveParticipantId(dataObj);
                  this.reasonForChange = null;
                } else {
                }
              });
          } else {
            this.isParticipantEditModalBoxVisible = false;
            this.isSaveBtnDisabled = true;
            this.initializeOtpInput();
            this.saveParticipantId(dataObj);
            this.reasonForChange = null;
          }
        } else {
          this.isParticipantEditModalBoxVisible = false;
          this.isSaveBtnDisabled = true;
          this.initializeOtpInput();
          this.reasonForChange = null;
        }
      });
    },
    isSiteTeamMember() {
      if (this.user.userRole == "Rater") {
        return false;
      } else {
        return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.user.readOnly || this.canCallCenterAccess || this.canCraUBAccess;
      }
    },
    canEditParticipantId() {
      if (this.studyResponse && !this.studyResponse.isParticipantIdEditable) {
        return (this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess) && (this.participantDetails.status == "NOTINVITED" || (this.participantDetails.userDefinedParticipantId && this.participantDetails.userDefinedParticipantId.trim() == "") || !this.participantDetails.userDefinedParticipantId);
      } else {
        return this.canPiAccess || this.canSubPIAccess || this.canStudyCoordinatorAccess;
      }
    },
    canEditParticipantInfo() {
      return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess;
    },
    truncateUserDefinedParticipantId() {
      let pId = this.participantDetails.userDefinedParticipantId;
      if (pId && pId.trim()) {
        if (pId.length > 24) {
          pId = pId.substring(0, 15) + "..." + pId.substring(pId.length - 4, pId.length);
        }
      }
      return pId;
    },
    convertArrayStringHtml(colorCodingMetaDataOld, userDefinedParticipantId) {
      let PIDid;
      let colorCodingMetaData = colorCodingMetaDataOld;
      if (this.studyData && this.studyData.participantIdFormatConfigured && this.studyData.participantIdFormatConfigured.colorCodingEnable) {
        colorCodingMetaData = this.studyData.participantIdColorCodingMetaData;
        //This if condition add for add ... in pid when Pid is greater than 24 otherwise else part done
        if (userDefinedParticipantId.length >= 24) {
          const firstPID = userDefinedParticipantId.substring(0, 15).split("");
          const lastPID = userDefinedParticipantId.substring(userDefinedParticipantId.length - 4, userDefinedParticipantId.length).split("");
          for (let i = 0; i <= colorCodingMetaData.length - 1; i++) {
            for (let j = 0; j <= firstPID.length - 1; j++) {
              if (colorCodingMetaData[i].colorCodeCharacter - 1 == j) {
                switch (colorCodingMetaData[i].colorCodeCondition) {
                  case "Is equal to":
                    if (colorCodingMetaData[i].colorCodeConditionValue == firstPID[j]) {
                      firstPID[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + firstPID[j] + "</span>";
                    }
                    break;
                  case "Is not equal to":
                    if (colorCodingMetaData[i].colorCodeConditionValue != firstPID[j]) {
                      firstPID[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + firstPID[j] + "</span>";
                    }
                    break;
                  case "None":
                    firstPID[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + firstPID[j] + "</span>";
                    break;
                }
              }
            }
          }
          for (let k = 0; k <= colorCodingMetaData.length - 1; k++) {
            for (let l = 0; l <= lastPID.length - 1; l++) {
              const m = l;
              const n = this.participantDetails.userDefinedParticipantId.length - 4;
              if (colorCodingMetaData[k].colorCodeCharacter - 1 > 16 && colorCodingMetaData[k].colorCodeCharacter - 1 == m + n) {
                switch (colorCodingMetaData[k].colorCodeCondition) {
                  case "Is equal to":
                    if (colorCodingMetaData[k].colorCodeConditionValue == lastPID[l]) {
                      lastPID[l] = "<span style=' color: " + colorCodingMetaData[k].color + " '>" + lastPID[l] + "</span>";
                    }
                    break;
                  case "Is not equal to":
                    if (colorCodingMetaData[k].colorCodeConditionValue != lastPID[l]) {
                      lastPID[l] = "<span style=' color: " + colorCodingMetaData[k].color + " '>" + lastPID[l] + "</span>";
                    }
                    break;
                  case "None":
                    lastPID[l] = "<span style=' color: " + colorCodingMetaData[k].color + " '>" + lastPID[l] + "</span>";
                    break;
                }
              }
            }
          }
          firstPID.push(".");
          firstPID.push(".");
          firstPID.push(".");
          PIDid = firstPID.concat(lastPID);
        } else {
          PIDid = userDefinedParticipantId.split("");
          for (let i = 0; i <= colorCodingMetaData.length - 1; i++) {
            for (let j = 0; j <= PIDid.length - 1; j++) {
              if (colorCodingMetaData[i].colorCodeCharacter - 1 == j) {
                switch (colorCodingMetaData[i].colorCodeCondition) {
                  case "Is equal to":
                    if (colorCodingMetaData[i].colorCodeConditionValue == PIDid[j]) {
                      PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                    }
                    break;
                  case "Is not equal to":
                    if (colorCodingMetaData[i].colorCodeConditionValue != PIDid[j]) {
                      PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                    }
                    break;
                  case "None":
                    PIDid[j] = "<span style=' color: " + colorCodingMetaData[i].color + " '>" + PIDid[j] + "</span>";
                    break;
                }
              }
            }
          }
        }
        let PIDConv = "";
        for (let i = 0; i <= PIDid.length - 1; i++) {
          PIDConv = PIDConv + PIDid[i];
        }
        return PIDConv;
      } else {
        return userDefinedParticipantId;
      }
    },
    withDrawParticipant() {
      this.yesConfirmBtnFlag = true;
      const dataObj = {
        studyId: this.studyId,
        status: "WITHDRAWSTUDY",
        id: this.participantDetails && this.participantDetails.id,
        siteId: this.participantDetails.siteId,
        countryId: this.participantDetails.countryId,
        participantLanguage: this.participantDetails.participantLanguage
      };
      this.$api.disqualifyFact(dataObj.id, this.studyId, dataObj).then(
        response => {
          if (!!response.body && response.body.warning) {
            this.$toastr.warning(response.body.warning);
          } else {
            this.$refs.editParticipantStatusModal.hide();
            this.$toastr.success((!!response.body && response.body.message) || "Participant withdrawal successful.");
            this.$router.push({
              name: "study-participants-list",
              params: { studyId: this.studyId }
            });
          }
          this.visitDetails = {};
        },
        error => {
          this.yesConfirmBtnFlag = false;
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while WithDrawing participant.");
        }
      );
    },
    openEditStatusModal(view) {
      this.isDropDownShow = false;
      this.selectedCurrentStatus = this.getStatusName(this.participantDetails.status);
      this.currentParticipantStatus = this.participantDetails.status;
      this.configureModifications();
      this.showActivitiesNotifications = false;
      this.$refs.editParticipantStatusModal.show();
      this.screenFailureReasons = [];
      this.otherScreenFailureReasons = "";
      if (view) {
        this.disableStatusEdit = true;
        this.showActivitiesNotifications = true;
        this.withModificationsLinkClickFlg = true;
        this.hideChangeBtn = false;
        this.modifyclickFlg = true;
        this.hidechangeStatusActiveWithModifyUpdate = true;
      } else {
        this.disableStatusEdit = false;
        this.hideChangeBtn = true;
        this.withModificationsLinkClickFlg = false;
        this.modifyclickFlg = false;
        this.hidechangeStatusActiveWithModifyUpdate = false;
      }
    },
    statusChanged() {
      this.isDropDownShow = true;
      this.otherDiscontinuedReason = "";
      this.selectedDiscontinuedReasons = [];
      this.otherReason = "";
      this.otherDisqualifyReason = "";
      this.selectedReason = "";
      this.disqualifyReason = "";
      if (this.currentParticipantStatus !== "ACTIVEWMODIFICATION") {
        this.showActivities = false;
        this.hideChangeStatus = false;
        this.withModificationsLinkClickFlg = false;
      } else {
        this.hideChangeStatus = false;
        this.configureModifications();
      }
      this.getReasonsList();
    },
    configureModifications(status) {
      if (this.currentParticipantStatus === "ACTIVEWMODIFICATION" || this.participantDetails.status === "ACTIVEWMODIFICATION") {
        if (status) {
          this.showActivities = true;
          this.showActivitiesNotifications = true;
        }
        this.$api.getAllActivitiesList(this.studyId).then(
          response => {
            this.tasks = response.body.tasks;
            this.notifications = response.body.customNotifications;
            this.disableActivitiesFlag = false;
            this.disableNotificationsFlag = false;
            this.notifications.forEach(notification => {
              if (notification.notificationScheduler.type === "milestone") {
                notification.notificationScheduler.milestoneString = notification.notificationScheduler.milestones.toString();
              }
            });
            if (this.participantDetails.status === "ACTIVEWMODIFICATION") {
              this.showActivities = true;
              if (this.participantDetails.statusChangeReason) {
                if (this.participantDetails.statusChangeReason.includes("Other")) {
                  const other = this.participantDetails.statusChangeReason.split(" ~ ");
                  this.selectedReason = other[0];
                  this.otherReason = other[1];
                } else {
                  this.selectedReason = this.participantDetails.statusChangeReason;
                }
              }
              this.$api.getDisabledList(this.studyId, this.participantDetails.id, this.participantDetails.id, this.studyId).then(
                response => {
                  const selectedTasks = response.body.tasks;
                  const selectedNotifications = response.body.customNotifications;
                  if (this.tasks.length === selectedTasks.length) {
                    this.disableActivitiesFlag = true;
                  } else {
                    this.disableActivitiesFlag = false;
                  }
                  if (this.notifications.length === selectedNotifications.length) {
                    this.disableNotificationsFlag = true;
                  } else {
                    this.disableNotificationsFlag = false;
                  }
                  this.tasks.forEach(task => {
                    selectedTasks.forEach(selectedTask => {
                      if (task.resourceId === selectedTask.resourceId) {
                        task.active = selectedTask.active;
                      }
                    });
                  });
                  this.notifications.forEach(notification => {
                    selectedNotifications.forEach(selectedNotification => {
                      if (notification.resourceId === selectedNotification.resourceId) {
                        notification.active = selectedNotification.active;
                      }
                    });
                  });
                  this.$forceUpdate();
                },
                error => {
                  this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting disabled activities list.");
                }
              );
            } else {
              if (this.getPredinedDisableTasks.length > 0 || this.getPredinedDisableCustomNotifications.length > 0) {
                const getTasks = this.tasks;
                const getNotifications = this.notifications;
                this.getPredinedDisableTasks.forEach(selectedTask => {
                  const getTasksIndexValue = getTasks.findIndex(task => task.resourceId === selectedTask.resourceId);
                  if (getTasksIndexValue >= 0) {
                    this.tasks[getTasksIndexValue].active = true;
                  }
                });
                this.getPredinedDisableCustomNotifications.forEach(selectedTask => {
                  const getNotificationsIndexValue = getNotifications.findIndex(task => task.resourceId === selectedTask.resourceId);
                  if (getNotificationsIndexValue >= 0) {
                    this.notifications[getNotificationsIndexValue].active = true;
                  }
                });
              } else {
                this.tasks.forEach(task => {
                  task.active = false;
                });
                this.notifications.forEach(notification => {
                  notification.active = false;
                });
              }
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting activities list.");
          }
        );
      }
    },
    disableActivities() {
      this.tasks.forEach(task => {
        task.active = !this.disableActivitiesFlag;
      });
    },
    disableNotifications() {
      this.notifications.forEach(notification => {
        notification.active = !this.disableNotificationsFlag;
      });
    },
    getStatuses() {
      let statuses = [];
      switch (this.participantDetails.status) {
        case "ACTIVE":
          statuses = [
            {
              name: "Active",
              value: "ACTIVE"
            }
          ];
          if (this.legacyVal) {
            statuses.push(
              {
                name: "Withdrawn",
                value: "WITHDRAWSTUDY"
              },
              {
                name: "Disqualified",
                value: "DISQUALIFIED"
              }
            );
          } else {
            statuses.push({
              name: "Discontinued",
              value: "DISCONTINUED"
            });
          }
          if (this.feature.length !== 0) {
            statuses.push({
              name: "Active with modifications",
              value: "ACTIVEWMODIFICATION"
            });
          }
          return statuses;
        case "ACTIVEWMODIFICATION":
          statuses = [
            {
              name: "Active with modifications",
              value: "ACTIVEWMODIFICATION"
            },
            {
              name: "Active",
              value: "ACTIVE"
            }
          ];
          if (this.legacyVal) {
            statuses.push(
              {
                name: "Withdrawn",
                value: "WITHDRAWSTUDY"
              },
              {
                name: "Disqualified",
                value: "DISQUALIFIED"
              }
            );
          } else {
            statuses.push({
              name: "Discontinued",
              value: "DISCONTINUED"
            });
          }
          return statuses;
        case "VERIFIED":
          statuses = [
            {
              name: "Verified",
              value: "VERIFIED"
            }
          ];
          if (this.legacyVal) {
            statuses.push(
              {
                name: "Withdrawn",
                value: "WITHDRAWSTUDY"
              },
              // {
              //   'name': 'Screening',
              //   'value': 'SCREENING'
              // },
              {
                name: "Disqualified",
                value: "DISQUALIFIED"
              }
            );
          } else {
            statuses.push({
              name: "Discontinued",
              value: "DISCONTINUED"
            });
          }
          if (this.feature.length !== 0) {
            statuses.push({
              name: "Active with modifications",
              value: "ACTIVEWMODIFICATION"
            });
          }
          return statuses;
        case "SCREENING":
          statuses = [
            {
              name: "Screening",
              value: "SCREENING"
            },
            {
              name: "Screening failed",
              value: "SCREENFAILED"
            },
            {
              name: "Active",
              value: "ACTIVE"
            }
          ];
          return statuses;
        case "INVITED":
          statuses = [
            {
              name: "Invited",
              value: "INVITED"
            }
          ];
          if (this.legacyVal) {
            statuses.push({
              name: "Disqualified",
              value: "DISQUALIFIED"
            });
          } else {
            statuses.push({
              name: "Discontinued",
              value: "DISCONTINUED"
            });
          }
          return statuses;
        case "NOTINVITED":
          statuses = [
            {
              name: "Imported",
              value: "NOTINVITED"
            },
            {
              name: "Active without app",
              value: "ACTIVEWITHOUTAPP"
            }
          ];
          return statuses;
        case "PRESCREENED":
          statuses = [
            {
              name: "Pre screened",
              value: "PRESCREENED"
            },
            {
              name: "Screen passed",
              value: "SCREENPASSED"
            },
            {
              name: "Screen failed",
              value: "SCREENFAILED"
            }
          ];
          return statuses;
        case "SCREENPASSED":
          statuses = [
            {
              name: "Screen passed",
              value: "SCREENPASSED"
            }
          ];
          this.disableStatusEdit = true;
          return statuses;
        case "ACTIVEWITHOUTAPP":
          statuses = [
            {
              name: "Active without App",
              value: "ACTIVEWITHOUTAPP"
            }
          ];
          if (this.legacyVal) {
            statuses.push({
              name: "Disqualified",
              value: "DISQUALIFIED"
            });
          } else {
            statuses.push({
              name: "Discontinued",
              value: "DISCONTINUED"
            });
          }
          return statuses;
      }
    },
    changeStatus() {
      if (this.currentParticipantStatus === this.participantDetails.status) {
        this.$refs.editParticipantStatusModal.hide();
        this.$toastr.warning("No status change has been detected.");
      } else if (this.currentParticipantStatus === "DISQUALIFIED") {
        if (this.disqualifyReason === "" || (this.disqualifyReason === "Other" && !this.otherDisqualifyReason)) {
          this.$toastr.error("Please select a reason for disqualifying the participant.");
        } else {
          this.hideChangeStatus = true;
        }
      } else if (this.currentParticipantStatus === "DISCONTINUED") {
        if (this.errors.any()) {
          this.$toastr.error("Please enter a reason for discontinuing the participant.");
        } else {
          this.hideChangeStatus = true;
        }
      } else if (this.currentParticipantStatus === "SCREENFAILED") {
        if (this.screenFailureReasons.length == 0) {
          this.$toastr.error("Please select a reason for screen failed the participant.");
        } else if (this.errors.any() || (this.screenFailureReasons.includes("Other") && !this.otherScreenFailureReasons)) {
          this.$toastr.error("Please enter a reason for screen failed the participant.");
        } else {
          this.hideChangeStatus = true;
        }
      } else {
        this.hideChangeStatus = true;
      }
      if (this.currentParticipantStatus === "ACTIVEWITHOUTAPP") {
        this.hideChangeStatus = true;
      }
    },
    confirmChangeStatus() {
      nprogress.start();
      this.yesConfirmBtnFlag = true;
      if (this.currentParticipantStatus === "DISQUALIFIED") {
        this.disqualifyParticipant();
      }
      if (this.currentParticipantStatus === "DISCONTINUED") {
        this.discontinueParticipant();
      }
      if (this.currentParticipantStatus === "ACTIVEWITHOUTAPP") {
        this.activeWithoutAppParticipant();
      }
      if (this.currentParticipantStatus === "SCREENPASSED" || this.currentParticipantStatus === "SCREENFAILED") {
        this.changePrescreenedStatus();
      } else if (this.currentParticipantStatus === "ACTIVEWMODIFICATION") {
        const selectedTasks = this.tasks.filter(task => task.active === true);
        const selectedNotifications = this.notifications.filter(notification => notification.active === true);
        const participantDisableConfigDTOObj = {};
        participantDisableConfigDTOObj.tasks = selectedTasks;
        participantDisableConfigDTOObj.customNotifications = selectedNotifications;
        let statusChange = " ";
        if (this.selectedReason === "Other") {
          statusChange = "Other" + " ~ " + this.otherReason;
        } else {
          statusChange = this.selectedReason;
        }
        const data = {
          studyId: this.studyId,
          id: this.participantDetails.id,
          email: this.participantDetails.email,
          siteId: this.participantDetails.siteId,
          status: "ACTIVEWMODIFICATION",
          statusChangeReason: statusChange,
          participantDisableConfigDTO: participantDisableConfigDTOObj,
          countryId: this.participantDetails.countryId,
          participantLanguage: this.participantDetails.participantLanguage
        };
        this.$api.postDisableActivitiesAndNotifications(this.studyId, this.participantDetails.id, data).then(
          () => {
            this.$refs.editParticipantStatusModal.hide();
            nprogress.done();
            this.$toastr.success("Status successfully updated.");
            document.location.reload();
          },
          error => {
            this.yesConfirmBtnFlag = false;
            nprogress.done();
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving modifications.");
          }
        );
      } else if (this.currentParticipantStatus === "ACTIVE") {
        this.updateToActive();
      } else if (this.currentParticipantStatus === "SCREENING") {
        this.updateToActive(true);
      }
    },
    updateChangeStatus() {
      const selectedTasks = this.tasks.filter(task => task.active === true);
      const selectedNotifications = this.notifications.filter(notification => notification.active === true);
      if (selectedTasks.length !== 0 || selectedNotifications.length !== 0) {
        this.disableChangeStatus = false;
      } else {
        this.disableChangeStatus = true;
      }
      if (this.tasks.length !== 0 && selectedTasks.length !== 0 && this.tasks.length === selectedTasks.length) {
        this.disableActivitiesFlag = true;
      } else {
        this.disableActivitiesFlag = false;
      }
      if (this.notifications.length !== 0 && selectedNotifications.length !== 0 && this.notifications.length === selectedNotifications.length) {
        this.disableNotificationsFlag = true;
      } else {
        this.disableNotificationsFlag = false;
      }
      this.$forceUpdate();
    },
    changePrescreenedStatus(invite) {
      const data = {
        participantId: this.participantDetails.id,
        siteId: this.participantDetails.siteId,
        screeningFailed: "0",
        screeningPassed: "0",
        invite: "0",
        email: this.participantDetails.email,
        participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
        participantLocalOffset: moment().format("Z")
      };
      if (invite) {
        data.invite = "1";
      } else if (this.currentParticipantStatus === "SCREENPASSED") {
        data.screeningPassed = "1";
      } else if (this.currentParticipantStatus === "SCREENFAILED") {
        if (this.screenFailureReasons.length == 0) {
          this.$toastr.error("Please select a reason for screen failed the participant.");
          this.yesConfirmBtnFlag = false;
          return;
        } else if (this.errors.any() || (this.screenFailureReasons.includes("Other") && !this.otherScreenFailureReasons)) {
          this.$toastr.error("Please enter a reason for screen failed the participant.");
          this.yesConfirmBtnFlag = false;
          return;
        }
        data.screeningFailed = "1";
        const reasonSelected = this.screenFailureReasons.length > 0 ? this.screenFailureReasons.filter(e => e != "Other") : [];
        data.screenFailureReasons = { reasons: [] };
        if (this.screenFailureReasons.includes("Other")) {
          data.screenFailureReasons.other = this.otherScreenFailureReasons;
        }
        data.screenFailureReasons.reasons = reasonSelected;
      }
      this.$api
        .postUpatedScreeningStatus(this.studyId, data)
        .then(response => {
          if (response) {
            this.$refs.editParticipantStatusModal.hide();
            if (invite) {
              this.$toastr.success("Invited successfully.");
            } else {
              this.$toastr.success("Status successfully updated.");
            }
            document.location.reload();
          }
        })
        .catch(err => {
          this.$toastr.error("Error while updating status.");
          this.yesConfirmBtnFlag = false;
          throw err;
        });
    },
    invite() {
      this.changePrescreenedStatus("invite");
    },
    checkIfAllTheOldValuesCleared() {
      const isArrEmpty = this.userDefinedArray[0].filter(ch => {
        return ch != null && ch != "";
      });
      return isArrEmpty.length == 0;
    },
    validateFields(oldFormat = false) {
      this.hasError = { idErrorMsg: null, reasonErrorMsg: null };
      this.isSaveBtnDisabled = false;
      this.participantIDdisabled = false;
      if (!this.userDefinedParticipantId || (this.userDefinedParticipantId && this.userDefinedParticipantId.trim() == "")) {
        this.participantIDdisabled = true;
      }
      if (oldFormat) {
        this.isSaveBtnDisabled = true;
        //this code Fpr when one of the value of oldFormat is removed and again add, Error msg not remove
        const isArrEmpty = this.userDefinedArray[0].filter(ch => {
          return ch == null || ch == "";
        });
        if (isArrEmpty.length) {
          this.hasError.idErrorMsg = "Incorrect Participant ID format.";
        } else {
          this.isSaveBtnDisabled = false;
        }

        if (this.checkIfAllTheOldValuesCleared()) {
          this.$nextTick(() => {
            this.isFormatUpdate = false;
            this.oldFormat = false;
          });
        }
        //this code For when one of the value of oldFormat is removed and again add, there is no msg come for reason
        if (this.studyResponse.isParticipantIdEditable && this.participantDetails.status != "NOTINVITED") {
          if (this.participantDetails.version >= 1 && !this.reasonForChange) {
            this.hasError.reasonErrorMsg = "Please specify the reason for change.";
            this.isSaveBtnDisabled = true;
          }
          if (this.reasonForChange && this.reasonForChange.length < 5) {
            this.hasError.reasonErrorMsg = "Please add more details.";
            this.isSaveBtnDisabled = true;
          }
        }
        return;
      }
      if (!this.studyResponse.participantIdFormatConfigured.isFormattingChecked && this.studyResponse.isParticipantIdRequired && this.userDefinedParticipantId == "" && this.userDefinedParticipantId.trim() == "") {
        this.isSaveBtnDisabled = true;
      }
      if (!this.studyResponse.participantIdFormatConfigured.isFormattingChecked && this.studyResponse.isParticipantIdRequired && (!this.userDefinedParticipantId || (this.userDefinedParticipantId && this.userDefinedParticipantId.trim() == ""))) {
        this.hasError.idErrorMsg = "Participant ID is required.";
        this.isSaveBtnDisabled = true;
      }

      if (this.studyResponse.isParticipantIdEditable && this.participantDetails.status != "NOTINVITED") {
        if (this.participantDetails.version >= 1 && !this.reasonForChange) {
          this.hasError.reasonErrorMsg = "Please specify the reason for change.";
          this.isSaveBtnDisabled = true;
        }
        if (this.reasonForChange && this.reasonForChange.length < 5) {
          this.hasError.reasonErrorMsg = "Please add more details.";
          this.isSaveBtnDisabled = true;
        }

        if (this.isFormatUpdate) {
          if (this.checkIfAllTheOldValuesCleared()) {
            this.$nextTick(() => {
              this.isFormatUpdate = false;
              this.oldFormat = false;
            });
          } else {
            const isArrEmpty = this.userDefinedArray[0].filter(ch => {
              return ch == null || ch == "";
            });
            if (isArrEmpty.length) {
              this.isSaveBtnDisabled = true;
              this.hasError.idErrorMsg = "Incorrect Participant ID format.";
            }
          }
          return;
        }
        if (!this.studyResponse.participantIdFormatConfigured.isFormattingChecked && this.userDefinedParticipantId == "" && this.userDefinedParticipantId.trim() == "") {
          this.isSaveBtnDisabled = true;
        }
        if (!this.studyResponse.participantIdFormatConfigured.isFormattingChecked && this.studyResponse.isParticipantIdRequired && (!this.userDefinedParticipantId || (this.userDefinedParticipantId && this.userDefinedParticipantId.trim() == ""))) {
          this.hasError.idErrorMsg = "Participant ID is required.";
          this.isSaveBtnDisabled = true;
        }
        if (this.studyResponse.isParticipantIdEditable && this.participantDetails.status != "NOTINVITED") {
          if (this.participantDetails.version >= 1 && !this.reasonForChange) {
            this.hasError.reasonErrorMsg = "Please specify the reason for change.";
            this.isSaveBtnDisabled = true;
          }
          if (this.reasonForChange && this.reasonForChange.length < 5) {
            this.hasError.reasonErrorMsg = "Please add more details.";
            this.isSaveBtnDisabled = true;
          }
        }
        if (this.studyResponse && this.studyResponse.participantIdFormatConfigured && this.studyResponse.participantIdFormatConfigured.isFormattingChecked) {
          const characters = this.formattingArray.formatArray[0].filter((ch, index) => {
            if (this.fixedCharactersIndex.indexOf(index) == -1 && ch != null) {
              return ch;
            }
          });
          const PID = characters.join("");
          // check for pid is required or not, pid length,
          if (characters.length == 0 && this.studyResponse.isParticipantIdRequired) {
            this.hasError.idErrorMsg = "Participant ID is required.";
            this.isSaveBtnDisabled = true;
          } else if (characters.length != 0 && characters.length != this.studyResponse.participantIdFormatConfigured.size - this.fixedCharactersIndex.length) {
            this.hasError.idErrorMsg = "Incorrect PID length.";
            this.isSaveBtnDisabled = true;
          } else if (this.studyResponse.participantIdFormatConfigured.isDisallowLetters && /[a-zA-Z]/g.test(PID)) {
            this.hasError.idErrorMsg = "Letters are not allowed.";
            this.isSaveBtnDisabled = true;
          } else if (this.studyResponse.participantIdFormatConfigured.isDisallowNumbers && /[0-9]/g.test(PID)) {
            this.hasError.idErrorMsg = "Numbers are not allowed.";
            this.isSaveBtnDisabled = true;
          } else if (this.studyResponse.participantIdFormatConfigured.isDisallowSpecialCharacters && /[[\\\];=!@#$%^&*(),'_.?":{}|<>+~/`-]/g.test(PID)) {
            this.hasError.idErrorMsg = "Special characters are not allowed.";
            this.isSaveBtnDisabled = true;
          }
        }
      }
    },
    initializeOtpInput() {
      // set otp logic
      if (this.studyResponse && this.studyResponse.participantIdFormatConfigured && this.studyResponse.participantIdFormatConfigured.isFormattingChecked) {
        this.studyResponse.participantIdFormatConfigured.size = this.studyResponse.participantIdFormatConfigured.size == 0 ? null : this.studyResponse.participantIdFormatConfigured.size;
        this.formattingArray = {
          formatArray: []
        };
        this.formattingArray.formatArray.push(JSON.parse(this.studyResponse.participantIdFormatConfigured.format));
        this.fixedCharactersIndex = [];
        this.formattingArray.formatArray[0].map((ch, index) => {
          if (ch != "" && ch != null) {
            this.fixedCharactersIndex.push(index);
          }
        });
      }
    },
    processTheParticipantId() {
      let characters = this.formattingArray.formatArray[0];
      // remove fixed characters from the string.
      if (this.oldFormat && this.userDefinedArray[0] != undefined) {
        this.userDefinedParticipantId = this.userDefinedArray[0].join("");
      } else {
        if (this.fixedCharactersIndex.length > 0) {
          characters = this.formattingArray.formatArray[0].filter((ch, index) => {
            if (this.fixedCharactersIndex.indexOf(index) > -1) {
              return ch;
            }
          });
        }
        this.userDefinedParticipantId = characters.length == 0 ? null : this.formattingArray.formatArray[0].join("");
      }
    },
    saveParticipantId(dataObj) {
      if (dataObj.reasonComment) {
        this.$api.saveUserDefinedParticipantIdV2(dataObj, this.studyId, this.participantDetails.id).then(
          response => {
            this.$root.$emit("updateUserDefinedPaticipantId", {
              userDefinedParticipantId: response.body.newUserDefinedParticipantId,
              participantId: this.participantDetails.id
            });
            this.$toastr.success("Participant ID updated successfully.");
            this.isParticipantEditModalBoxVisible = false;
            this.isSaveBtnDisabled = true;
            this.checkIfParticipantIdFormatHasBeenChanged();
            this.initializeOtpInput();
            this.oldFormat = false;
            if (this.isDataLoadingFinishFlag) {
              this.$emit("updateFlagPID", dataObj);
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the participant id.");
          }
        );
      } else {
        this.$api.updateParticipantIdFact(dataObj).then(
          response => {
            this.participantDetails.userDefinedParticipantId = response.body.userDefinedParticipantId;
            this.$root.$emit("updateUserDefinedPaticipantId", {
              userDefinedParticipantId: response.body.userDefinedParticipantId,
              participantId: this.participantDetails.id
            });
            this.$forceUpdate();
            this.$toastr.success("Participant ID updated successfully.");
            this.isParticipantEditModalBoxVisible = false;
            this.isSaveBtnDisabled = true;
            this.checkIfParticipantIdFormatHasBeenChanged();
            this.initializeOtpInput();
            this.oldFormat = false;
            if (this.isDataLoadingFinishFlag) {
              this.$emit("updateFlagPID", dataObj);
            }
          },
          error => {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating the participant id.");
          }
        );
      }
    },
    resetAllTheValues() {
      this.hasError = {
        idErrorMsg: null,
        reasonErrorMsg: null
      };
      this.isSaveBtnDisabled = true;
      this.reasonForChange = null;
      this.checkIfParticipantIdFormatHasBeenChanged();
      if (this.isFormatUpdate) {
        this.oldFormat = true;
        this.initializeOtpInput();
      }
    },
    onCloseOfModalBox() {
      let ifPIDUpdated = true;
      // checking if pid is updated
      if (this.studyResponse.participantIdFormatConfigured.isFormattingChecked) {
        this.processTheParticipantId();
      }
      ifPIDUpdated = this.userDefinedParticipantId != null && this.userDefinedParticipantId != this.participantDetails.userDefinedParticipantId;
      if (!ifPIDUpdated) {
        this.$refs.editParticipantModal.hide();
        return;
      }
      this.$swal({
        title: "No changes will be saved. Would you like to continue?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.$refs.editParticipantModal.hide();
        }
      });
    },
    checkIfFixedCharactersAreSame() {
      if (!this.studyResponse) {
        return;
      }
      const fixedCharactersIndex = [];
      const formatArr = JSON.parse(this.studyResponse.participantIdFormatConfigured.format);
      formatArr.map((ch, index) => {
        if (ch != "" && ch != null) {
          fixedCharactersIndex.push({
            index: index,
            character: ch
          });
        }
      });

      for (let i = 0; i < fixedCharactersIndex.length; i++) {
        if (fixedCharactersIndex[i].character != this.participantDetails.userDefinedParticipantId[fixedCharactersIndex[i].index]) {
          this.isFormatUpdate = true;
          break;
        }
      }
      return this.isFormatUpdate;
    },
    checkIfParticipantIdFormatHasBeenChanged() {
      this.userDefinedArray = [];
      this.isFormatUpdate = false;
      if (this.participantDetails.userDefinedParticipantId != undefined && this.participantDetails.userDefinedParticipantId != "" && this.participantDetails.userDefinedParticipantId != null) {
        // check user define participant id with latest one.
        // check if size is equal to latest format then only fetch fixed characters
        if ((this.studyResponse && this.studyResponse.participantIdFormatConfigured.size) != (this.participantDetails.userDefinedParticipantId && this.participantDetails.userDefinedParticipantId.length)) {
          this.isFormatUpdate = true;
          if (this.participantDetails.userDefinedParticipantId != null && this.participantDetails.userDefinedParticipantId != "") {
            this.userDefinedArray.push(this.participantDetails.userDefinedParticipantId.split(""));
          } else {
            this.userDefinedArray.push(new Array(Number(this.studyResponse.participantIdFormatConfigured.size)).fill(null));
          }
          this.oldFormat = true;
        } else if ((this.studyResponse && this.studyResponse.participantIdFormatConfigured.size) == (this.participantDetails.userDefinedParticipantId && this.participantDetails.userDefinedParticipantId.length)) {
          this.isFormatUpdate = this.checkIfFixedCharactersAreSame();
          if (this.isFormatUpdate) {
            if (this.participantDetails.userDefinedParticipantId != null && this.participantDetails.userDefinedParticipantId != "") {
              this.userDefinedArray.push(this.participantDetails.userDefinedParticipantId.split(""));
            } else {
              this.userDefinedArray.push(new Array(Number(this.studyResponse.participantIdFormatConfigured.size)).fill(null));
            }
            this.oldFormat = true;
          }
        }
      }
      if (!this.isFormatUpdate) {
        if (this.participantDetails.userDefinedParticipantId && (this.participantDetails.userDefinedParticipantId != null || this.participantDetails.userDefinedParticipantId != "")) {
          this.formattingArray.formatArray = [];
          this.formattingArray.formatArray.push(this.participantDetails.userDefinedParticipantId.split(""));
        }
      }
    },
    getPredinedDisabledLists() {
      this.$api.getPredinedAllActivitiesList(this.studyId).then(
        response => {
          this.getPredinedDisableTasks = response.body.tasks;
          this.getPredinedDisableCustomNotifications = response.body.customNotifications;
          if (this.getPredinedDisableTasks.length > 0 || this.getPredinedDisableCustomNotifications.length > 0) {
            this.reasons = [
              {
                name: "Discontinued study drug",
                value: "Discontinued study drug"
              }
            ];
          }
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting disabled activities list.");
        }
      );
    },
    getDisableChgStatus() {
      if (this.getPredinedDisableTasks.length > 0 || this.getPredinedDisableCustomNotifications.length > 0) {
        return false;
      } else if (this.hideChangeBtn && this.currentParticipantStatus === "ACTIVEWMODIFICATION") {
        return false;
      } else if (this.currentParticipantStatus === "DISCONTINUED" && this.checkDiscontinuedReasons()) {
        return true;
      } else {
        return this.showActivities && this.disableChangeStatus;
      }
    },
    updateToActive(isScreening = false) {
      const selectedTasks = this.tasks.filter(task => task.active === true);
      const selectedNotifications = this.notifications.filter(notification => notification.active === true);
      const participantDisableConfigDTOObj = {};
      participantDisableConfigDTOObj.tasks = selectedTasks;
      participantDisableConfigDTOObj.customNotifications = selectedNotifications;
      let statusChange = " ";
      if (this.selectedReason === "Other") {
        statusChange = "Other" + " ~ " + this.otherReason;
      } else {
        statusChange = this.selectedReason;
      }
      const data = {
        studyId: this.studyId,
        id: this.participantDetails.id,
        email: this.participantDetails.email,
        siteId: this.participantDetails.siteId,
        status: "ACTIVE",
        statusChangeReason: statusChange,
        participantDisableConfigDTO: participantDisableConfigDTOObj,
        countryId: this.participantDetails.countryId,
        participantLanguage: this.participantDetails.participantLanguage
      };
      if (isScreening == true) {
        data.screening = true;
      }
      this.$api.postDisableActivitiesAndNotifications(this.studyId, this.participantDetails.id, data).then(
        () => {
          this.$refs.editParticipantStatusModal.hide();
          nprogress.done();
          this.$toastr.success("Status successfully updated.");
          document.location.reload();
        },
        error => {
          this.yesConfirmBtnFlag = false;
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving modifications.");
        }
      );
    },
    cancelConfirmation() {
      this.hideChangeStatus = false;
      this.$refs.editParticipantStatusModal.hide();
    },
    updateActivities() {
      const selectedTasks = this.tasks;
      const selectedNotifications = this.notifications;
      const participantDisableConfigDTOObj = {};
      participantDisableConfigDTOObj.tasks = selectedTasks;
      participantDisableConfigDTOObj.customNotifications = selectedNotifications;
      let statusChange = " ";
      if (this.selectedReason === "Other") {
        statusChange = "Other" + " ~ " + this.otherReason;
      } else {
        statusChange = this.selectedReason;
      }
      const data = {
        studyId: this.studyId,
        id: this.participantDetails.id,
        email: this.participantDetails.email,
        siteId: this.participantDetails.siteId,
        status: "ACTIVEWMODIFICATION",
        statusChangeReason: statusChange,
        participantDisableConfigDTO: participantDisableConfigDTOObj,
        countryId: this.participantDetails.countryId,
        participantLanguage: this.participantDetails.participantLanguage
      };
      this.$api.postDisableActivitiesAndNotifications(this.studyId, this.participantDetails.id, data).then(
        () => {
          this.$refs.editParticipantStatusModal.hide();
          nprogress.done();
          this.$toastr.success("Activities/Notifications successfully updated.");
          document.location.reload();
        },
        error => {
          this.yesConfirmBtnFlag = false;
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving modifications.");
        }
      );
    },
    selectSiteToTransfer(site) {
      this.siteSelected = true;
      this.oldsite = this.newSite;
      this.newSite = site;
      if (Object.keys(this.oldsite).length != 0) {
        document.getElementById("selectedSite" + this.oldsite.userSiteId).style.background = "#ffffff";
      }
      const v = document.getElementById("selectedSite" + site.userSiteId);
      v.style.background = "#e3e7e8";
    },
    doSomethingOnHidden() {
      setTimeout(function() {
        $("[id^='selectedSite']").css("background-color", "#ffffff");
      }, 500);
    },
    toggleShowMore() {
      this.participantDetails.showMore = !this.participantDetails.showMore;
      this.$forceUpdate();
    },
    activeWithoutAppParticipant() {
      this.yesConfirmBtnFlag = true;
      const dataObj = {
        studyId: this.studyId,
        status: "ACTIVEWITHOUTAPP",
        email: this.participantDetails && this.participantDetails.email ? this.participantDetails.email : null,
        id: this.participantDetails.id,
        siteId: this.participantDetails.siteId,
        countryId: this.participantDetails.countryId,
        participantLanguage: this.participantDetails.participantLanguage,
        participantLocalTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
        participantLocalOffset: moment().format("Z"),
        startDateLocal: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZZ"),
        startDateOffset: moment().format("Z"),
        registeredTime: moment().format("YYYY-MM-DDTHH:mm:ss.SSS+0000"),
        registrationDate: moment().format("YYYY-MM-DDTHH:mm:ss"),
        startDateUtc: moment().format("YYYY-MM-DDTHH:mm:ss")
      };
      this.$api.activeWithoutApp(dataObj.id, this.studyId, dataObj).then(
        () => {
          this.$toastr.success("Participant successfully activated");
          this.$refs.editParticipantStatusModal.hide();
          this.$router.push({
            name: "study-participants-list",
            params: {
              studyId: this.studyId
            }
          });
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving modifications.");
        }
      );
    },
    checkParticipantRegistrationConfigDetails(data) {
      let isparticipantDetailsVisible = false;
      if (this.participantInfoData.length > 0) {
        this.participantInfoData.map(item => {
          if (item.key.toLowerCase() == data.toLowerCase()) {
            isparticipantDetailsVisible = item.isVisible;
          }

          if (item.key.toLowerCase() == "dob".toLowerCase() || item.key.toLowerCase() == "birthDate".toLowerCase()) {
            this.showDOB = true;
          } else if (item.key.toLowerCase() == "dobWithMonthYear".toLowerCase()) {
            this.showDobWithMonthYear = true;
          } else if (item.key.toLowerCase() == "dobWithYear".toLowerCase()) {
            this.showDobWithYear = true;
          }
        });
        return isparticipantDetailsVisible;
      }
    },
    getRegistration() {
      const self = this;
      this.$api.getRegistrationFact(this.studyId).then(response => {
        if (response.body.participantRegistrationConfigDetails) {
          self.participantInfoData = response.body.participantRegistrationConfigDetails;
        }
      });
    },
    toggleApproveStatus() {
      if (this.approvedFlageValue) {
        this.markAsUnapproved();
      } else {
        this.markAsApproved();
      }
    },

    markAsApproved() {
      let title, desc, submitBtnText, cancelBtnText;
      title = "Approve Participant";
      desc = `Herewith I confirm the completeness and correctness of the data by applying an electronic signature, using my account name and password.
                This electronic signature is the legally binding equivalent of my handwritten signature. I understand that this electronic signature is
                assigned only to my account name and password; no other person is authorized to use these.<br /><br />
                Please enter your username and password to approve.`;
      submitBtnText = "Yes, approve";
      cancelBtnText = "No, do not approve";

      this.userAuthModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
        this.updateApprovalStatus(!this.approvedFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },
    markAsUnapproved() {
      let title, yesBtnText, noBtnText;
      title = "Are you sure you want to rescind approval for this participant?";
      yesBtnText = "Yes, unapprove";
      noBtnText = "No, do not unapprove";

      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.updateApprovalStatus(!this.approvedFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },

    toggleVerifyStatus() {
      let title, yesBtnText, noBtnText;

      if (this.verifiedFlageValue) {
        title = "Are you sure you want to rescind verification for this participant?";
        yesBtnText = 'Yes, change to "unverified" status';
        noBtnText = 'No, do not change to "unverified" status';
      } else {
        title = "Have you thoroughly verified this participant?";
        yesBtnText = 'Yes, change to "verified" status';
        noBtnText = 'No, do not change to "verified" status';
      }

      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.updateVerifyStatus(!this.verifiedFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },

    toggleSignOffStatus() {
      let title, desc, submitBtnText, cancelBtnText;
      title = this.signedOffFlageValue ? "Unsigned Off Participant" : "Signed Off Participant";
      desc = `Herewith I confirm the completeness and correctness of all data entered into the THREAD Platform by applying an electronic signature,
                using my account name and password. This electronic signature is the legally binding equivalent of my handwritten signature.
                I understand that this electronic signature is assigned only to my account name and password;
                no other person is authorized to use these.<br /><br />Please enter username and password to sign this document.`;
      submitBtnText = this.signedOffFlageValue ? "Yes, Unsigned Off" : "Yes, Signed Off";
      cancelBtnText = this.signedOffFlageValue ? "No, do not Unsigned Off" : "No, do not Signed Off";

      this.userAuthModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
        this.updateSignedOffStatus(!this.signedOffFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },

    toggleReviewStatus() {
      if (this.reviewedFlageValue) {
        this.markAsUnreviewed();
      } else {
        this.markAsReviewed();
      }
    },
    markAsReviewed() {
      let title, desc, submitBtnText, cancelBtnText;
      title = "Review Participant";
      desc = `I hereby confirm the completeness and correctness of all data entered within this document by applying an electronic signature,
                using my account username and password. This electronic signature is the legally binding equivalent of my handwritten signature.
                I understand that this electronic signature is assigned only to my account username and password;
                no other person is authorized to use my account information.<br/><br/>Please enter your username and password to sign this document.`;
      submitBtnText = "Yes, review";
      cancelBtnText = "No, do not review";

      this.userAuthModal.open(title, desc, submitBtnText, cancelBtnText).then(() => {
        this.updateReviewStatus(!this.reviewedFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },
    markAsUnreviewed() {
      let title, yesBtnText, noBtnText;
      title = "Are you sure you want to rescind the review for this participant?";
      yesBtnText = 'Yes, change to "Unreviewed" status';
      noBtnText = 'No, do not change to "Unreviewed" status';

      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.updateReviewStatus(!this.reviewedFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },
    toggleLockedStatus() {
      if (this.removeActivityEditIcon) {
        return
      }
      let title, yesBtnText, noBtnText;
      if (this.lockedFlageValue) {
        title = "Are you sure you want to unlock this participant?";
        yesBtnText = 'Yes, change to "unlocked" status';
        noBtnText = 'No, do not change to "unlocked" status';
      } else {
        title = "Do you wish to lock this participant?";
        yesBtnText = 'Yes, change to "locked" status';
        noBtnText = 'No, do not change to "locked" status';
      }

      this.$refs.userConfirmationModal.open(title, yesBtnText, noBtnText).then(() => {
        this.updateLockStatus(!this.lockedFlageValue, this.studyId, this.participantId, null, this.userDetailsObj);
      });
    },
    getStatusName(status) {
      const statusName = this.statusOptions.filter(e => e.value === status);
      if (statusName && statusName.length > 0) {
        return statusName[0].name;
      }
    },
    onInputUserPhone({ country }) {
      this.participantInfo.smsCountryIsoName = country.iso2.toLowerCase();
      this.participantInfo.countryCode = `+${country.dialCode}`;
    },
    checkDiscontinuedReasons() {
      return this.selectedDiscontinuedReasons.length === 0 || (this.checkOtherReason && !this.otherDiscontinuedReason);
    },
    getStatusesList() {
      this.$api.getStatusList(this.studyId).then(response => {
        this.participantStatuses = utils.getStatusListJSON(response.body.STATUS);
      });
    },
    getReasonsList() {
      this.$api.getReasonList(this.studyId).then(response => {
        if (this.currentParticipantStatus != "DISCONTINUED") {
          this.disqualifyReasons = utils.getReasonListJSON(response.body, this.currentParticipantStatus);
        } else {
          this.discontinuedReasons = utils.getReasonListJSON(response.body, this.currentParticipantStatus);
        }
      });
    },
    checkLegacyValue() {
      this.$api.getLegacyData(this.studyId).then(response => {
        if (response) {
          this.legacyVal = response.body;
        }
      });
    },
    editCustomFields(item, i) {
      this.participantInfo = cloneDeep(this.participantDetails);
      this.oIndex = i;
      this.iIndex = i + 1;
      this.participantDetailsCustomFileds = true;
    },
    updateCustomFieldValue() {
      if (this.participantInfo.customFields.length == 1) {
        this.participantInfo.regCustomField1 = this.participantInfo.customFields[0].registrationCustomFieldValue1;
      }
      if (this.participantInfo.customFields.length == 2) {
        this.participantInfo.regCustomField1 = this.participantInfo.customFields[0].registrationCustomFieldValue1;
        this.participantInfo.regCustomField2 = this.participantInfo.customFields[1].registrationCustomFieldValue2;
      }
      if (this.participantInfo.customFields.length == 3) {
        this.participantInfo.regCustomField1 = this.participantInfo.customFields[0].registrationCustomFieldValue1;
        this.participantInfo.regCustomField2 = this.participantInfo.customFields[1].registrationCustomFieldValue2;
        this.participantInfo.regCustomField3 = this.participantInfo.customFields[2].registrationCustomFieldValue3;
      }

      const payload = {
        studyId: this.$route.params.studyId,
        participantId: this.$route.params.participantId,
        // isPhone: true,
        data: this.participantInfo
      };
      this.$api.updateParticipantInfoFact(payload).then(
        response => {
          this.participantDetailsCustomFileds = false;
          window.$("#participantDetailsCustomFileds").modal("hide");
          // this.participantDetails.customFields = response.data.customFields;
          const _this = this;
          setTimeout(function() {
            _this.$emit("getParticipantInformation");
            _this.$toastr.success(response.bodyText);
          }, 1500);
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating Participant Info.");
        }
      );
    },
    cancelCustomFieldValue() {
      this.participantInfo = cloneDeep(this.participantDetails);
      this.participantDetailsCustomFileds = false;
      window.$("#participantDetailsCustomFileds").modal("hide");
    },
    isSiteTeamUsers() {
      if (this.user.userRole == "Rater" || this.user.userRole == "SiteDataLock") {
        return false;
      } else {
        return this.canHomeHealthAccess || this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.canCallCenterAccess || this.user.readOnly;
      }
    },
    //----------------------------------------------------------
    //        AgeRange and Gender Dropdown handle Here         |
    //----------------------------------------------------------
    getParticipantLookUpDropdataList() {
      this.$api.getParticipantConfigurationList(this.studyId).then(
        response => {
          const participantConfigList = response.body;
          const ageRange = [];
          const genderExtended = [];
          const genderStandard = [];
          const meta = this.participantDetails.genderMeta;
          participantConfigList.map(item => {
            if (item.lookupType == "Gender" && item.lookupOptions == "Standard") {
              genderStandard.push(item);
            } else if (item.lookupType == "Gender" && item.lookupOptions == "Extended") {
              genderExtended.push(item);
            } else if (item.lookupType == "ageRange" && item.lookupOptions == "Normal") {
              ageRange.push(item);
            }
          });
          this.gender = meta.toUpperCase() == "STANDARD" ? genderStandard : genderExtended;
          this.ageRange = ageRange;
        },
        error => {
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting history.");
        }
      );
    },
    setGenderValue(genderIdentifier) {
      this.gender.map(item => {
        if (item.lookupId == genderIdentifier) {
          this.participantInfo.gender = item.lookupValue;
        }
      });
    },
    setAgeRangeValue(ageRangeIdentifier) {
      this.ageRange.map(item => {
        if (item.lookupId == ageRangeIdentifier) {
          this.participantInfo.ageRange = item.lookupValue;
        }
      });
    },

    shoulsShowCustomFields() {
      return !(
        this.user.userRole == "Rater" ||
        this.user.userRole == "Dm" ||
        this.user.userRole == "Cra" ||
        this.user.userRole == "StudyManager" ||
        this.user.userRole == "SystemAdmin" ||
        this.user.userRole == "StudyAdmin" ||
        this.user.userRole == "Biostatistics" ||
        this.user.userRole == "Pharmacovigilance" ||
        this.user.userRole == "Quality" ||
        this.user.userRole == "Interviewer" ||
        this.user.userRole == "Support"
      );
    },

    canSiteTeamUserEditCustomFields() {
      return this.canPiAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.user.readOnly || this.canHomeHealthAccess;
    },

    isCustomFieldsDataVisible() {
      return this.canPiAccess || this.canCraUBAccess || this.canStudyCoordinatorAccess || this.canSubPIAccess || this.user.readOnly || this.canHomeHealthAccess || this.user.userRole == "CallCenter" || this.user.userRole == "SiteDataLock";
    },
    ShouldDisableSaveBtn() {
      let shouldDisable = false;
      if (this.studyResponse && this.studyResponse.participantIdFormatConfigured.isFormattingChecked && this.isFormatUpdate === false && this.userDefinedParticipantId) {
        shouldDisable = this.formattingArray.formatArray[0].join("") === this.userDefinedParticipantId;
      } else if (this.studyResponse && this.studyResponse.participantIdFormatConfigured.isFormattingChecked && this.isFormatUpdate === true && this.userDefinedParticipantId) {
        shouldDisable = this.userDefinedArray[0].join("") === this.userDefinedParticipantId;
      } else if (this.participantDetails && this.participantDetails.userDefinedParticipantId && this.participantDetails.userDefinedParticipantId === this.userDefinedParticipantId) {
        shouldDisable = true;
      } else if (this.isSaveBtnDisabled) {
        shouldDisable = true;
      }
      return shouldDisable;
    },
    openEditEmailModal() {
      this.newEmailId = this.participantDetails.email;
      this.resetEmailModalValues();
      this.$refs.editEmailModal.show();
    },
    updateEmailId(isDuplicateAllowed = "false") {
      const user = localStorageService.getItem("userObj");
      const dataObj = {
        studyId: this.studyId,
        siteId: this.participantDetails.siteId,
        optionForChange: this.selectedReasonForEmailChange == "Other" ? "Other" : this.selectedReasonForEmailChange,
        reasonForChange: this.selectedReasonForEmailChange == "Other" ? this.reasonForEmailChangeEntered : this.selectedReasonForEmailChange,
        newEmailId: this.newEmailId,
        oldEmailId: this.participantDetails.email,
        participantId: this.participantDetails.id,
        isDuplicateAllowed: isDuplicateAllowed,
        userId: user.id
      };
      this.$api.saveNewEmailId(dataObj, this.participantDetails.id, isDuplicateAllowed).then(
        () => {
          this.$root.$emit("updateNewEmailId", {
            participantId: this.participantDetails.id
          });
          this.$toastr.success("Participant email updated successfully.");
          this.$refs.editEmailModal.hide();
          this.$refs.duplicateEmailModal.hide();
        },
        error => {
          if (error.body && error.body.message && error.body.message == "CONFLICT") {
            this.$refs.duplicateEmailModal.show();
          } else {
            this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while updating participant email");
          }
        }
      );
    },
    confirmUpdateEmailId() {
      this.$swal({
        title: "Are you sure you want to change the email for this participant?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#4a4a4a",
        cancelButtonColor: "#1e8fe1",
        confirmButtonText: "Cancel",
        cancelButtonText: "Update"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.updateEmailId();
        }
      });
    },
    resetEmailModalValues() {
      this.reasonForEmailChangeEntered = null;
      this.selectedReasonForEmailChange = "";
    },
    emailReasonChange(changedReason) {
      if (changedReason == "Other") {
        this.$validator.validate("participantEmailChangeReason");
      }
    },
    disableActvityLockUnlockStatus() {
      let dataString = localStorage.getItem('thread-userObj');
      let userDetails = JSON.parse(dataString);
      if(userDetails.restrictions && (userDetails.restrictions.includes('activity_response.lock') || userDetails.restrictions.includes('activity_response.unlock'))){
        this.removeActivityEditIcon = true;
      }
      else{
        this.removeActivityEditIcon = false;
      }
    }
  },
  mounted() {
    this.approvalStatusTextSetNewStatus = this.approvedStatusText;
    this.approvedFlageValue = this.isApproved;
    this.verifiedStatusTextNewStatus = this.verifiedStatusText;
    this.verifiedFlage = this.isVerified;
    this.reviewedStatusTextNewStatus = this.reviewedStatusText;
    this.reviewedFlageValue = this.isReviewed;
    this.lockedStatusTextNewStatus = this.lockedStatusText;
    this.lockedFlageValue = this.isLocked;
    this.signedOffStatusTextNewStatus = this.signedOffStatusText;
    this.signedOffFlageValue = this.isSignedOff;
    this.$validator.localize("en", dict);
    const param = {
      studyId: this.$route.params.studyId,
      participantId: this.$route.params.participantId
    };
    this.$api.getSiteTransferData(param).then(
      response => {
        this.transferHistory = response.body;
        if (this.transferHistory) {
          this.transferHistory.forEach(ele => {
            if (ele.createdAt !== null && ele.createdBy !== null && ele.reviewedBy !== null && ele.fromSiteId !== null && ele.toSiteId !== null) {
              this.isAvailableHistory = true;
            }
          });
        }
      },
      error => {
        this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while getting history.");
      }
    );
    const toggledFeatures = this.$store.getters.getStudyToggledFeatures ? this.$store.getters.getStudyToggledFeatures : JSON.parse(window.localStorage.getItem("toggledFeatures"));
    this.feature = toggledFeatures.filter(toggledFeature => (toggledFeature.featureKey === "ParticipantStatusActiveWModification" && toggledFeature.enabled === true) || (toggledFeature.featureKey === "ParticipantStatusActiveWModificationV2" && toggledFeature.enabled === true));
    this.getPredinedDisabledLists();
    this.getRegistration();
    this.getStatusesList();
    this.checkLegacyValue();
    this.getFormStatuses(this.studyId, this.participantId);
    this.userAuthModal = this.$refs.userVerificationModal;
    this.setDefaultCountryDropdown();
    $("#participantDetailsModifyModal").on("shown.bs.modal", evt => {
      if (evt.relatedTarget.dataset && evt.relatedTarget.dataset.type) {
        this.editenabledfield(evt.relatedTarget.dataset.type);
      }
    });
    this.disableActvityLockUnlockStatus();
  },
  updated() {
    //TUR-61129
    const self = this;
    window.$("#participantDetailsModifyModal").on("hidden.bs.modal", function() {
      self.participantModifyValue = "";
      self.participantDetailsModifyModal = false;
      self.isVerificationModal = false;
    });
    window.$('[data-toggle="popover"]').popover();
    //TUR-61129
  }
};
</script>

<style lang="scss" scoped>
.pii-non-pii-wrapper {
  background-color: #f9f9fb;
  padding-top: 20px;
  .toggle-wrapper {
    width: 100%;
  }
  .btn-continue-prim {
    width: 110px;
    margin: 0 0 0 10px;
    background-color: #4c8ce4;
  }

  .toggle-text {
    text-align: center;
    cursor: pointer;
    font-weight: 600;
    font-size: 13px;
    width: 80px;
    margin: 0 auto;
    padding-bottom: 5px;

    &.colls {
      width: 80px;
    }

    span {
      background-image: url(/static/img/arrow-down-blue.png) !important;
      height: 20px;
      display: inline-block;
      background-repeat: no-repeat;
      width: 20px;
      vertical-align: text-bottom;
      background-position-x: -2px;
    }

    .collapsed {
      vertical-align: top;
      transform: rotate(180deg);
      background-position-y: -2px;
      background-position-x: -2px;
    }
  }

  .card {
    background: #f9f9fb;
    border-top: none;
    border-left: none;
    border-right: none;

    .card-body {
      padding: 0 3px 15px 0;
    }
  }

  .seperator {
    width: 100%;
    background: #e4e8eb;
    height: 1px;
    margin: 0 auto;
  }

  .separator {
    background: #e4e8eb;
    height: 1px;
    margin: 0 15px 15px;
  }

  .action-btn {
    border: solid 0.5px #e4e8eb;
    background-color: #ffffff;
    color: #4c8ce4;
    transition-duration: 0.6s;
    height: 35px;
    font-size: 14px;
  }

  #collapse-piiandnon-pii {
    position: relative;
    z-index: 10;
  }

  .custom-threadid-width {
    max-width: 27%;
  }

  .status-width {
    max-width: 10.5%;
    padding-left: 20px;
  }

  .name-width {
    max-width: 9%;
  }

  .gender-width {
    max-width: 9%;
  }

  .custom-dob-width {
    max-width: 10%;
  }

  .max-width-24 {
    max-width: 24%;
    min-width: 19%;
  }

  .max-width-16 {
    max-width: 16%;
  }

  .max-width-20 {
    max-width: 20%;
    min-width: 17%;
  }

  .max-width-14 {
    max-width: 14%;
  }

  .max-width-12 {
    max-width: 12%;
  }

  .device-usage {
    .img-wrapper {
      width: 10px;
      height: 10px;
      display: inline-block;
      margin-right: 5px;

      img {
        width: 100%;
      }
    }
  }

  .page {
    color: #a8a8a8;
  }

  .value {
    color: #525252;
    font-size: 15px;
    word-wrap: break-word;
  }

  .header-key {
    font-size: 12px;
    img{
    &.disabled {
        display: none;
      }
    }
  }
  .edit-email-modal {
    .btn {
      width: 100px;
      height: 35px;
      border-radius: 18px;
      border: none;
      font-size: 14px;
    }
    .cancel-btn {
      background-color: #e3e3e3;
      color: #4a4a4a;
    }
    .update-btn {
      background-color: #4c8ce4;
      color: #fff;
    }
  }
  .duplicate-email-modal {
    p {
      font-size: 16px;
      color: #4a4a4a;
      font-family: RobotoRegular;
    }
    .btn {
      width: 150px;
      height: 45px;
      border-radius: 22px;
      border: none;
    }
    .cancel-btn {
      background-color: #e3e3e3;
      color: #4a4a4a;
    }
    .yes-btn {
      background-color: #4c8ce4;
      color: #fff;
    }
  }
}
@media (min-width: 320px) and (max-width: 768px) {
  .pii-non-pii-wrapper {
    height: auto !important;
    padding: 10px;
    box-shadow: none;
  }
}
.pencil-icon {
  cursor: pointer;
}

.truncate {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.field-padding-left {
  padding-left: 17px;
}

* {
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}

.blue-banner {
  background-color: #eaf0f4;
  height: 65px;
  padding: 9px;

  .title {
    color: #b0bac9;
  }

  .description {
    color: #4a4a4a;
  }
}

.highlighted {
  border-radius: 3px;
  border: solid 2px #d3dfe4;
  width: 100%;

  &.text-area {
    width: 100%;
  }
}

.save-btn-already-save {
  border-radius: 25px;
  width: 100px;
}

.error-style {
  color: #f16559;
}

// when telehalth call started
.telehealth-call {
  .pii-non-pii-wrapper {
    .header-key {
      font-size: 10px;
    }

    .value {
      font-size: 10px;
    }

    .toggle-text {
      font-size: 11px;
    }

    .action-btn {
      font-size: 11px;
    }
  }
}

.rowDiv {
  background-color: #eaf0f4;
}

select.custom-select {
  background: #fff url(/static/img/arrow-down.png) no-repeat center;
}

.change-btn {
  width: 170px;
  border-radius: 20px;
  background-color: #4c8ce4;
}

.cancel-button {
  background-color: #e0e0e0;
  color: #000000;
  border: 1px solid #e0e0e0;
}

.activitiesDiv {
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 10px 15px;
  border-radius: 3px;
  height: 160px;
  overflow-y: scroll;
}

// .toggle-modification-wrapper {
//   position: relative;
//   bottom: 15px;
// }
.modificationsText {
  width: 130px;
  color: #4c8ce4;
  font-size: 11px;
  line-height: 1;
  cursor: pointer;
}

.close-icon {
  cursor: pointer;
  float: right;
  position: relative;
  left: 17px;
}

.subHeading {
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 5px;
}

.icon-edit {
  cursor: pointer;
  position: relative;
  bottom: 2px;
  max-width: 12px;
  @media (max-width: 1280px) {
    bottom: 2px;
    max-width: 10px;
    margin-left: 2px !important;
    i {
      font-size: 10px;
    }
  }
}

.ellipsisClass {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cross {
  width: 27px;
  height: 27px;
  float: right;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
  }
}

.modal-title {
  clear: both;
}

.site-modal button {
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  color: #959fa4;
  font-size: 14px;
  position: relative;
  bottom: 0;
}

.modal-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #000000;
}

.siteId-box {
  width: 297px;
  height: 255px !important;
  padding: 10px 5px 14px 5px;
  object-fit: contain;
  border-radius: 4px;
  border: solid 2px #d3dfe4;
  background-color: #ffffff;
}

.Site-ID {
  margin: 6.5px 0 6.5px 10px;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #666669;
}

.Site-Name {
  padding: 6px 7px 0px 40px;
  font-size: 14px;
  line-height: 1.43;
  text-align: left;
  color: #666669;
}

.page-modal {
  position: relative;
  width: 100%;
  height: 200px;
}

.content {
  width: 100%;
}

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}

.page::after {
  content: "";
  position: absolute;
  z-index: -1;
  height: calc(100% - 20px);
  top: 10px;
  right: -1px;
  width: 5px;
  background: #666;
}

.wrapper::-webkit-scrollbar {
  display: block;
  width: 6px;
}

.wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.wrapper::-webkit-scrollbar-thumb {
  border-right: none;
  border-left: none;
}

.wrapper::-webkit-scrollbar-track-piece:end {
  background: transparent;
  margin-bottom: 10px;
}

.wrapper::-webkit-scrollbar-track-piece:start {
  background: transparent;
  margin-top: 10px;
}

//dropdown css
.filter-form-box .select-scroll::-webkit-scrollbar {
  width: 8px;
  /* width of the entire scrollbar */
}

.filter-form-box .select-scroll::-webkit-scrollbar-track {
  background: transparent;
  /* color of the tracking area */
}

.filter-form-box .select-scroll::-webkit-scrollbar-thumb {
  background-color: #b0bac9;
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 3px solid transparent;
  /* creates padding around scroll thumb */
}

.select-scroll {
  scrollbar-width: thin;
  /* "auto" or "thin"  */
  scrollbar-color: #e6e9ed transparent;
  /* scroll thumb & track */
}

.filter-form-box select {
  width: 100%;
  font-size: 12px;
  height: 40px;
  border-radius: 3px;
  background-color: #f5f8fa;
  color: #666669;
  border-radius: 2px;
  border: solid 1px #ced4da;
}

#select-question {
  background-position: right 50% !important;
  background-repeat: no-repeat;
  background-image: url(/static/img/arrow-down.png);
}

.siteId-input .th-comman-select-box {
  color: #4a4a4a !important;
  text-transform: capitalize;
}

.overSelect {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}

#showsiteId {
  position: relative;
  top: 0px;
  background: #fff;
  width: 100%;
  height: fit-content;
  border-radius: 4px;
  padding-bottom: 10px;
  overflow: hidden;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#showsiteId label:first-child {
  background-color: #f5f8fa;
}

#showsiteId label {
  font-size: 14px;
  color: #000;
  float: left;
  width: 275px;
  line-height: 30px;
  margin-bottom: 0px;
}

.pi-width {
  width: 100% !important;
  padding: 0 16px !important;
}

.form-control:disabled,
.form-control {
  background-color: #ffffff;
  opacity: 1;
}

#showsiteId label:hover {
  background-color: #f5f8fa;
}

.modal-btn {
  width: 94px;
  height: 30px;
  color: #ffffff;
  border-radius: 4px;
  background-color: #4c8ce4;
}

.modal-footer button {
  border: none;
  font-size: 12px;
}

.text-gray {
  color: #4a4a4a;
}

.modal:before {
  content: "";
  display: inline-block;
  height: 100%;
  vertical-align: middle;
}

.modal-dialog {
  display: inline-block;
  vertical-align: middle;
}

#showSiteTransferReason {
  background: #fff;
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: fit-content;
  border-radius: 4px;
  overflow: hidden;
  z-index: 1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.25);
}

#siteIdSelectBox {
  position: relative;
}

.nsiteId-input.form-group input:focus,
.nsiteId-input .form-control:focus {
  box-shadow: none;
}

#showSiteTransferReason label {
  float: left;
  line-height: 30px;
  margin-bottom: 0px;
  font-family: Roboto;
  font-size: 15px;
  font-weight: 500;
  color: #666669;
}

#showSiteTransferReason label:hover,
#showLanguageDrop label:hover {
  background-color: #f5f8fa;
}

.siteIdModel-2 .modal-dialog {
  width: 339px;
  max-height: 350px;
  padding: 24px 18px 32px 17px;
  object-fit: contain;
  border-radius: 4px;
  background-color: #ffffff;
}
.siteIdModel-2 .modal-dialog.verifyPhone {
  width: 515px;
}
.siteIdModel-2 .verifyPhone .modal-body {
  padding: 1rem !important;
  padding-top: 0 !important;
}
.siteIdModel-2 .verifyPhone .modal-header {
  border-bottom: 0;
}
.siteIdModel-2 .modal-content {
  box-shadow: none;
}

.siteIdModel-2 .modal-body {
  padding: 0 !important;
}

.siteIdModel-2 .question-title {
  margin: 0 2px 17px;
  font-family: RobotoRegular;
  font-size: 18px;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;
}

.siteIdModel-2 .note {
  margin: 16px 20px 0;
  font-family: RobotoRegular;
  font-size: 14px;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;
}

.siteIdModel-2 .participant-info {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  padding: 10px 10px 15px;
  border-radius: 0 imp !important;
  background-color: #f0f3f5d0;
}

.btn-1 {
  padding: 6px 35px;
  color: #666669;
  background-color: #e3e3e3;
}

.btn-2 {
  padding: 6px 35px;
  color: #ffffff;
  background-color: #4c8ce4;
}

.text-lightGray {
  color: #acacb1d7;
}
@media (min-width: 576px) {
  #transferIdModal .modal-dialog {
    width: 553px;
    margin: 1.75rem auto;
  }
}
#transferIdModal .modal-header {
  border-bottom: none;
  padding-top: 24px !important;
}
#transferIdModal .modal-header .close {
  padding: 0.4rem;
  margin: -1.5rem -1rem -1rem auto;
}
#transferIdModal .modal-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  color: #000000;
}
#transferIdModal .modal-body {
  padding-top: 0 !important;
  position: relative;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 1rem;
}
#transferIdModal .table {
  width: 100%;
  max-width: 100%;
  margin-bottom: none;
  background-color: #eaf0f4;
}
#transferIdModal .table thead th {
  font-family: Roboto;
  font-size: 12px;
  font-weight: bold;
  color: #b0bac9;
}
#transferIdModal .table tbody td {
  font-family: Roboto;
  font-size: 14px;
  color: #4a4a4a;
  padding-bottom: 15px;
  padding-left: 15px;
}
#transferIdModal .table thead th {
  border-bottom: None;
  padding-top: 10px;
  padding-left: 15px;
}
#transferIdModal .table th,
#transferIdModal .table td {
  border-top: none;
  padding: 0.25rem;
}
.link {
  color: #1e8fe1 !important;
  cursor: pointer;
}
.mandatory {
  color: red;
}
.ml-5 {
  margin-left: 5px;
}
.pd-0 {
  padding: 0px !important;
}
@media screen and (min-width: 360px) and (max-width: 768px) {
  #edit-participant-modal .modal-dialog {
    position: relative;
    width: 100%;
    margin: 0;
    pointer-events: none;
  }
  #edit-participant-modal .modal-dialog .highlighted {
    border-radius: 3px;
    border: solid 2px #d3dfe4;
    width: 100%;
  }
  .pr {
    padding-right: 0px;
  }
  .pl {
    padding-left: 5px;
  }
  .px {
    padding-right: 0px;
    padding-left: 0px;
  }
}
.help_icon {
  color: #949496;
  border: none !important;
  outline: none !important;
  cursor: pointer;
}
.fa-pencil {
  cursor: pointer;
}

.row {
  flex-wrap: wrap !important;
}
.mx-datepicker {
  width: 250px !important;
  margin-top: 12px !important;
}
#participantDetailsModifyModal {
  top: -10px;
}
.mx-calendar {
  width: 303px;
}
/* New styles for Participant Statuses */
.value {
  &.collapse-trigger {
    .dropdown-icon {
      transform: rotate(0deg);
    }
    &.collapsed {
      .dropdown-icon {
        transform: rotate(180deg);
      }
    }
  }
}
.pii-non-pii-wrapper .value {
  word-wrap: break-word;
}
.arrow-change {
  padding: 0;
  margin-top: -40px;
  margin-right: -25px;
  font-size: 40px;
}

.error {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 0;
  padding-left: 0;
}
.participant-static-text {
  font-weight: bold;
  color: #666669;
  font-size: 14px;
  font-family: Roboto-Medium;
  text-align: center;
  line-height: 22px;
}
.pencil-icon-disabled {
  cursor: default;
  opacity: 0.5;
}
</style>
<style scoped lang="scss" src="@/assets/otp-input.scss"></style>
